import { l as te } from "./lodash-5ofSKtz3.mjs";
import { j as l } from "./jsx-runtime-3tyXYecC.mjs";
import E, { useRef as le, useReducer as Gt, useState as N, createContext as Kt, memo as qt, useEffect as U, useLayoutEffect as Vt, useCallback as ce, useMemo as _, isValidElement as Yt, cloneElement as Ve, useContext as Xt, createElement as Se } from "react";
import { f as g } from "./index-LyFokDcn.mjs";
import { m as A } from "./tss-DN0acMKN.mjs";
import { s as Qt } from "./index-DDl_rLOB.mjs";
import { M as F, d as R } from "./constants-CnFYFetN.mjs";
import { I as oe } from "./icon-button-BxDvkq_l.mjs";
import { B as ge } from "./button-CUHBhgeQ.mjs";
import { I as Zt } from "./ChevronLeft8x13-CHzitOe8.mjs";
import { S as Ye } from "./select-DjbIs9Ff.mjs";
import { I as B } from "./icon-v2-DGtVEk7e.mjs";
import { T as Jt } from "./text-field-ZOMRKQAY.mjs";
import { N as er } from "./nub-h9wiBv_F.mjs";
import { c as me } from "./index-DkZ16bcJ.mjs";
import { F as tr } from "./flex-Cc3osQLf.mjs";
import { a as rr } from "./X10x10-Bso1Otyr.mjs";
import { g as nr } from "./_commonjsHelpers-BkfeUUK-.mjs";
import { I as Pe } from "./CircleX12x12-CLsP0OlE.mjs";
import { D as ir } from "./divider-Dq5lrAFK.mjs";
import { A as or } from "./autocomplete-multiple-BTMdCjN1.mjs";
const ft = (t) => E.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 5 9", width: "5", height: "9" }, t),
  E.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    E.createElement(
      "g",
      { transform: "translate(-401 -334)" },
      E.createElement("path", { d: "M401 343 401 334 406 338.5z" })
    )
  )
);
ft.displayName = "CaretRight5x9";
const gt = (t) => E.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 8 13", width: "8", height: "13" }, t),
  E.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    E.createElement("path", { fillRule: "nonzero", d: "M7.60931572,7.41916201 L2.27599473,12.6191042 C2.01555089,12.8730347 1.67451464,13 1.33333025,13 C0.992145851,13 0.651109604,12.8730347 0.390665762,12.6191042 C-0.130221921,12.1116765 -0.130221921,11.2882079 0.390665762,10.7807802 L4.78117412,6.50007222 L0.390665762,2.21921979 C-0.130221921,1.71179209 -0.130221921,0.888323463 0.390665762,0.380895768 C0.911553445,-0.126965256 1.7552552,-0.126965256 2.27614288,0.380895768 L7.60946387,5.58083799 C8.1302034,6.08826569 8.1302034,6.91187876 7.60931572,7.41916201 Z" })
  )
);
gt.displayName = "ChevronRight8x13";
const ht = (t) => E.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 14", width: "14", height: "14" }, t),
  E.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    E.createElement(
      "g",
      { fillRule: "nonzero" },
      E.createElement("path", { d: "M52,197 C48.1340067,197 45,193.865993 45,190 C45,186.134007 48.1340067,183 52,183 C55.8659933,183 59,186.134007 59,190 C59,193.865993 55.8659933,197 52,197 Z M48.25,189 C47.8333333,189.242269 47.625,189.575602 47.625,190 C47.625,190.636597 47.9738576,191 48.25,191 L51,191 L51,193.75 C51,194.026142 51.2852173,194.375 52,194.375 C52.7147827,194.375 53,194.026142 53,193.75 L53,191 L55.75,191 C56.0261424,191 56.375,190.733582 56.375,190 C56.375,189.266418 56.0261424,189 55.75,189 L53,189 L53,186.25 C53,185.973858 52.7302348,185.625 52,185.625 C51.2697652,185.625 51,185.973858 51,186.25 L51,189 L48.25,189 Z", transform: "translate(-45 -183)" })
    )
  )
);
ht.displayName = "CirclePlus14x14";
const pt = (t) => E.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 11", width: "14", height: "11" }, t),
  E.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    E.createElement("path", { fillRule: "nonzero", d: "M0.341848747,6.27775247 C-0.113927975,5.84851279 -0.113927975,5.15160943 0.341719118,4.72224753 L5.00837498,0.322296419 C5.4641517,-0.10743214 6.20239074,-0.10743214 6.65816746,0.322296419 C7.11394418,0.751658315 7.11394418,1.44843946 6.65816746,1.87780136 L2.81647265,5.50006111 L6.65816746,9.12219864 C7.11394418,9.55156054 7.11394418,10.2483417 6.65816746,10.6777036 C6.4302791,10.8925679 6.13187238,11 5.83333603,11 C5.53479969,11 5.23639297,10.8925679 5.00850461,10.6777036 L0.341848747,6.27775247 Z M7.34184875,6.27775247 C6.88607202,5.84851279 6.88607202,5.15160943 7.34171912,4.72224753 L12.008375,0.322296419 C12.4641517,-0.10743214 13.2023907,-0.10743214 13.6581675,0.322296419 C14.1139442,0.751658315 14.1139442,1.44843946 13.6581675,1.87780136 L9.81647265,5.50006111 L13.6581675,9.12219864 C14.1139442,9.55156054 14.1139442,10.2483417 13.6581675,10.6777036 C13.4302791,10.8925679 13.1318724,11 12.833336,11 C12.5347997,11 12.236393,10.8925679 12.0085046,10.6777036 L7.34184875,6.27775247 Z" })
  )
);
pt.displayName = "DoubleChevronLeft14x11";
const mt = (t) => E.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 14 11", width: "14", height: "11" }, t),
  E.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    E.createElement("path", { fillRule: "nonzero", d: "M13.6581513,6.27775247 L8.99149539,10.6777036 C8.76360703,10.8925679 8.46520031,11 8.16666397,11 C7.86812762,11 7.5697209,10.8925679 7.34183254,10.6777036 C6.88605582,10.2483417 6.88605582,9.55156054 7.34183254,9.12219864 L11.1835274,5.50006111 L7.34183254,1.87780136 C6.88605582,1.44843946 6.88605582,0.751658315 7.34183254,0.322296419 C7.79760926,-0.10743214 8.5358483,-0.10743214 8.99162502,0.322296419 L13.6582809,4.72224753 C14.113928,5.15160943 14.113928,5.84851279 13.6581513,6.27775247 Z M6.65815125,6.27775247 L1.99149539,10.6777036 C1.76360703,10.8925679 1.46520031,11 1.16666397,11 C0.86812762,11 0.569720903,10.8925679 0.341832542,10.6777036 C-0.113944181,10.2483417 -0.113944181,9.55156054 0.341832542,9.12219864 L4.18352735,5.50006111 L0.341832542,1.87780136 C-0.113944181,1.44843946 -0.113944181,0.751658315 0.341832542,0.322296419 C0.797609265,-0.10743214 1.5358483,-0.10743214 1.99162502,0.322296419 L6.65828088,4.72224753 C7.11392798,5.15160943 7.11392798,5.84851279 6.65815125,6.27775247 Z" })
  )
);
mt.displayName = "DoubleChevronRight14x11";
const ve = (t) => E.createElement(
  "svg",
  Object.assign({ "data-bhr-grim": "BHR_GRIM", viewBox: "0 0 21 16", width: "21", height: "16" }, t),
  E.createElement(
    "g",
    { fillRule: "evenodd", stroke: "none", strokeWidth: 1 },
    E.createElement("path", { d: "M14.0285384,6.09161091 C14.0285384,5.12093942 15.202644,4.63487713 15.8892342,5.32146736 L15.8892342,5.32146736 L21.0001258,10.5 L15.8892342,15.6787114 C15.202644,16.3653016 14.0285384,15.8785128 14.0285384,14.9078413 L14.0285384,14.9078413 L14.0285384,12 L10.453101,12 C9.65098926,12 9,11.3330172 9,10.5301789 C9,9.72734062 9.65098926,9.02967052 10.453101,9.02967052 L10.453101,9.02967052 L14.0285384,9.02967052 Z M5.5,0 C6.32842712,-1.52179594e-16 7,0.671572875 7,1.5 L7,4 L9.5,4 C10.3284271,4 11,4.67157288 11,5.5 C11,6.32842712 10.3284271,7 9.5,7 L7,7 L7,9.5 C7,10.3284271 6.32842712,11 5.5,11 C4.67157288,11 4,10.3284271 4,9.5 L4,7 L1.5,7 C0.671572875,7 1.01453063e-16,6.32842712 0,5.5 C-1.01453063e-16,4.67157288 0.671572875,4 1.5,4 L4,4 L4,1.5 C4,0.671572875 4.67157288,1.52179594e-16 5.5,0 Z" })
  )
);
ve.displayName = "PlusArrow21x16";
const Xe = A()(({ constructs: t, mode: e, palette: r, spacing: n, typography: i }) => ({
  blankStateIcon: {
    display: "flex",
    justifyContent: "center",
    marginBottom: g.ifFeature("encore", n(3), 16),
    "& svg": {
      fill: g.ifFeature("encore", t.icon.neutral.medium, r.gray[700])
    }
  },
  blankStateText: g.ifFeature(
    "encore",
    {
      color: t.text.neutral.medium,
      fontSize: i.medium.fontSize,
      fontWeight: i.fontWeightRegular,
      lineHeight: i.medium.lineHeight,
      padding: n(0, 7),
      textAlign: "center"
    },
    {
      color: r.gray[700],
      fontSize: i.h3.fontSize,
      fontWeight: i.fontWeightBold,
      lineHeight: i.h3.lineHeight,
      padding: "0 25px",
      textAlign: "center"
    }
  ),
  blankStateContainer: {
    alignItems: g.ifFeature("encore", "center"),
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    height: g.ifFeature("encore", "100%", 374),
    justifyContent: "center",
    outline: e === F.Dye ? `1px solid ${R.main}` : void 0
  }
}));
function sr(t) {
  const { classes: e, icon: r, text: n } = t, { classes: i } = g.ifFeature("encore", Xe(), Xe(void 0, { props: { classes: e } }));
  return /* @__PURE__ */ l.jsxs("div", { className: i.blankStateContainer, "data-container": "blank-state", children: [
    r && /* @__PURE__ */ l.jsx("div", { className: i.blankStateIcon, children: r }),
    /* @__PURE__ */ l.jsx("div", { className: i.blankStateText, children: n })
  ] });
}
const Qe = A()(({ mode: t, spacing: e }) => ({
  buttonControlContainer: g.ifFeature(
    "encore",
    {
      display: "flex",
      flexDirection: "column",
      gap: e(1),
      outline: t === F.Dye ? `1px solid ${R.main}` : void 0
    },
    {
      boxSizing: "border-box",
      marginTop: 15,
      outline: t === F.Dye ? `1px solid ${R.main}` : void 0,
      padding: "0 16px"
    }
  ),
  buttonContainer: {
    marginBottom: 4,
    "&:last-of-type": {
      marginBottom: 0
    }
  }
}));
function vt(t) {
  const { onClickAddAll: e, onClickAddHighlighted: r, onClickRemoveHighlighted: n, onClickRemoveAll: i, classes: o, biId: s } = t, { classes: a } = g.ifFeature("encore", Qe(), Qe(void 0, { props: { classes: o } }));
  return g.ifFeature(
    "encore",
    /* @__PURE__ */ l.jsxs("div", { className: a.buttonControlContainer, children: [
      /* @__PURE__ */ l.jsx(
        oe,
        {
          "aria-label": window.jQuery ? $.__("Select all items") : "Select all items",
          "data-bi-id": s && `${s}-add-all-button`,
          icon: "chevrons-right-solid",
          onClick: e,
          size: "small",
          type: "button",
          variant: "outlined"
        }
      ),
      /* @__PURE__ */ l.jsx(
        oe,
        {
          "aria-label": window.jQuery ? $.__("Select highlighted items") : "Select highlighted items",
          "data-bi-id": s && `${s}-add-selected-button`,
          icon: "chevron-right-solid",
          onClick: r,
          size: "small",
          type: "button",
          variant: "outlined"
        }
      ),
      /* @__PURE__ */ l.jsx(
        oe,
        {
          "aria-label": window.jQuery ? $.__("Remove all items") : "Remove all items",
          "data-bi-id": s && `${s}-remove-all-button`,
          icon: "chevron-left-solid",
          onClick: n,
          size: "small",
          type: "button",
          variant: "outlined"
        }
      ),
      /* @__PURE__ */ l.jsx(
        oe,
        {
          "aria-label": window.jQuery ? $.__("Remove highlighted items") : "Remove highlighted items",
          "data-bi-id": s && `${s}-remove-selected-button`,
          icon: "chevrons-left-solid",
          onClick: i,
          size: "small",
          type: "button",
          variant: "outlined"
        }
      )
    ] }),
    /* @__PURE__ */ l.jsxs("div", { className: a.buttonControlContainer, children: [
      /* @__PURE__ */ l.jsx("div", { className: a.buttonContainer, children: /* @__PURE__ */ l.jsx(
        ge,
        {
          "aria-label": window.jQuery ? $.__("Select all items") : "Select all items",
          clickAction: e,
          "data-bi-id": s && `${s}-add-all-button`,
          icon: /* @__PURE__ */ l.jsx(mt, {}),
          outline: !0,
          secondary: !0,
          size: "teenie",
          type: "button",
          width: 1
        }
      ) }),
      /* @__PURE__ */ l.jsx("div", { className: a.buttonContainer, children: /* @__PURE__ */ l.jsx(
        ge,
        {
          "aria-label": window.jQuery ? $.__("Select highlighted items") : "Select highlighted items",
          clickAction: r,
          "data-bi-id": s && `${s}-add-selected-button`,
          icon: /* @__PURE__ */ l.jsx(gt, {}),
          outline: !0,
          secondary: !0,
          size: "teenie",
          type: "button",
          width: 1
        }
      ) }),
      /* @__PURE__ */ l.jsx("div", { className: a.buttonContainer, children: /* @__PURE__ */ l.jsx(
        ge,
        {
          "aria-label": window.jQuery ? $.__("Remove all items") : "Remove all items",
          clickAction: n,
          "data-bi-id": s && `${s}-remove-all-button`,
          icon: /* @__PURE__ */ l.jsx(Zt, {}),
          outline: !0,
          secondary: !0,
          size: "teenie",
          type: "button",
          width: 1
        }
      ) }),
      /* @__PURE__ */ l.jsx("div", { className: a.buttonContainer, children: /* @__PURE__ */ l.jsx(
        ge,
        {
          "aria-label": window.jQuery ? $.__("Remove highlighted items") : "Remove highlighted items",
          clickAction: i,
          "data-bi-id": s && `${s}-remove-selected-button`,
          icon: /* @__PURE__ */ l.jsx(pt, {}),
          outline: !0,
          secondary: !0,
          size: "teenie",
          type: "button",
          width: 1
        }
      ) })
    ] })
  );
}
const ar = A()(({ constructs: t, mode: e, palette: r, spacing: n, typography: i }) => {
  var o;
  return {
    root: g.ifFeature(
      "encore",
      {
        alignItems: "center",
        fill: t.text.neutral.medium,
        display: "flex",
        gap: g.ifFeature("encore", n(1), n(0.5)),
        outline: e === F.Dye ? `1px solid ${R.main}` : void 0
      },
      {
        backgroundColor: r.gray[100],
        boxSizing: "border-box",
        display: "flex",
        height: 58,
        outline: e === F.Dye ? `1px solid ${R.main}` : void 0,
        padding: 12
      }
    ),
    addFilterButtonContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      marginLeft: g.ifFeature("encore", 0, 9)
    },
    floatingIcon: {
      fill: r.gray[700],
      "&:hover": {
        fill: r.primary.main
      }
    },
    plusSelectIcon: {
      alignItems: "center",
      display: "flex",
      fontSize: (o = i.biggie) == null ? void 0 : o.fontSize,
      height: "28px",
      justifyContent: "center",
      width: "30px"
    }
  };
});
function cr(t) {
  return t.map((e) => ({ ...e, selected: !1 }));
}
function ye(t, e, r, n, i) {
  if (!Array.isArray(e) || !Array.isArray(t)) {
    const c = Array.isArray(e) ? "array" : typeof e, u = Array.isArray(t) ? "array" : typeof e;
    throw new Error(
      `Expected arrays but got ${u} for currentSelectedOptions and ${c} for currentAvailableOptions`
    );
  }
  const o = [], s = e.filter((c) => c.selected ? !0 : (o.push(c), !1));
  if (s.length === 0)
    return;
  const a = cr([...t]);
  r(o), n(i([...a, ...s]));
}
function lr(t, e) {
  const r = t.toString().toLowerCase().trim();
  return r === "" ? e : Array.isArray(e) ? [...e].filter((n) => Qt.hasWordStartingWith(n.title.toString(), r)) : [];
}
function ur(t, e, r) {
  if (!Array.isArray(t))
    return [];
  let n = !1;
  const i = [];
  for (let o = 0; o < t.length; o++) {
    const { disabled: s = !1 } = t[o];
    if (!s && n && i.push(o), !s && (t[o] === t[r] || t[o] === t[e])) {
      if (n)
        break;
      i.push(o), n = !0;
    }
  }
  return i;
}
function yt(t) {
  if (!Array.isArray(t))
    return [];
  const e = [...t];
  return e.sort((r, n) => {
    const i = r.title.toString().toLowerCase(), o = n.title.toString().toLowerCase();
    return i < o ? -1 : i > o ? 1 : 0;
  }), e;
}
function dr(t, e) {
  let r;
  if (!Array.isArray(t))
    throw new Error(`Expected an array but got ${typeof t}`);
  return Array.isArray(e) && e.length > 0 ? r = t.filter((n) => {
    const { value: i } = n;
    let o = !0;
    for (let s = 0; s < e.length; s++) {
      const a = e[s];
      if (typeof i == "object" && i && te.isObjectLike(i)) {
        if (i[a.filterId] !== a.value) {
          o = !1;
          break;
        }
      } else {
        o = !1;
        break;
      }
    }
    return o;
  }) : r = [...t], r;
}
function fr(t, e) {
  if (!Array.isArray(t))
    throw new Error(`Expected array for first argument but received: ${typeof t}`);
  let r = {};
  return Array.isArray(e) ? r = e.reduce((n, i) => (n[i.rowKey] = i.selected, n), {}) : console.error(`Expected array for selectedItems but received: ${typeof e}`), t.map((n) => ({ ...n, selected: r[n.rowKey] === !0 }));
}
function gr(t, e) {
  const r = Array.isArray(t), n = Array.isArray(e);
  if (r && n)
    return t.length > 0 ? dr(e, t) : [...e];
  const i = r ? "array" : typeof t, o = n ? "array" : typeof e;
  throw new Error(`Arrays expected but received ${i} for filters and ${o} for filteredAvailable`);
}
function hr(t, e) {
  return t.length > 0 ? e.filter((r) => !t.find((n) => n.rowKey === r.rowKey)) : [...e];
}
const K = (t, e, r = 0) => e === void 0 ? -1 : t === e || t === -1 && e === 0 || t === r && e === r - 1 ? 0 : -1, St = () => {
  const t = le();
  return (e, r, n, i = !1) => {
    const o = te.cloneDeep(e), s = e.findIndex((u) => u.rowKey === r);
    let a;
    const c = t == null ? void 0 : t.current;
    if (n.shiftKey && c !== void 0 && c !== null && c !== r) {
      const u = e.findIndex((d) => d.rowKey === c), f = ur(e, u, s), p = !o[s].selected;
      f.forEach((d) => {
        o[d].selected = p;
      });
    } else n.metaKey || n.altKey || n.ctrlKey ? o[s].selected = !o[s].selected : i ? o.forEach((u) => {
      u.subcategory === r ? (u.selected = !0, a = u.rowKey) : u.selected = !1;
    }) : (o.forEach((u) => {
      u.selected = !1;
    }), o[s].selected = !0);
    return t && (t.current = i ? a : r), o;
  };
};
function pr(t) {
  const {
    availableOptions: e = [],
    sortList: r = yt,
    selectedOptions: n = [],
    setAvailableOptions: i,
    setSelectedOptions: o
  } = t, s = St(), a = () => {
    const h = [...n, ...e], v = h.filter((S) => S.disabled === !0), m = h.filter((S) => S.disabled !== !0);
    i(v), o(r(m));
  }, c = () => {
    ye(n, e, i, o, r);
  }, u = () => {
    ye(e, n, o, i, r);
  }, f = () => {
    const h = [...e, ...n];
    i(r(h)), o([]);
  };
  function p(h, v) {
    const m = s(e, h.key, v);
    return i(m), m;
  }
  function d(h, v) {
    const m = s(n, h.key, v);
    return o(m), m;
  }
  return {
    availableOptions: e,
    selectedOptions: n,
    onClickAddAll: a,
    onClickAddHighlighted: c,
    onClickRemoveHighlighted: u,
    onClickRemoveAll: f,
    useOnAvailableSelect: p,
    useOnSelectedSelect: d
  };
}
function ho(t) {
  const {
    availableOptions: e = [],
    sortList: r = yt,
    selectedOptions: n = [],
    setAvailableOptions: i,
    setSelectedOptions: o
  } = t, s = St(), a = (f, p) => {
    const d = te.cloneDeep(n), h = d.filter((b) => b.subcategory === f || b.title === f), v = d.filter((b) => b.subcategory === p || b.title === p), m = d.findIndex((b) => b.rowKey === h[0].rowKey), S = d.findIndex(
      (b) => b.rowKey === h[h.length - 1].rowKey
    );
    let y = d.findIndex((b) => b.rowKey === v[0].rowKey);
    if (d.splice(m, S - m + 1), S < y) {
      const b = d.findIndex(
        (I) => I.rowKey === v[v.length - 1].rowKey
      );
      d.splice(b + 1, 0, ...h);
    } else
      y = d.findIndex((b) => b.rowKey === v[0].rowKey), d.splice(y, 0, ...h);
    o(d);
  }, c = (f, p, d = !1) => {
    const h = s(e, f.key, p, d);
    return ye(n, h, i, o, r), h;
  };
  function u(f, p, d = !1) {
    const h = s(n, f.key, p, d);
    return ye(e, h, o, i, r), h;
  }
  return {
    availableOptions: e,
    selectedOptions: n,
    useOnAvailableSelect: c,
    useOnSelectedSelect: u,
    reorderSubcategories: a
  };
}
var se = /* @__PURE__ */ ((t) => (t.CLEAR_FIRST_FILTER = "clearFirstFilter", t.CLEAR_SECOND_FILTER = "clearSecondFilter", t.SELECT_FIRST_FILTER = "selectFirstFilter", t.SELECT_SECOND_FILTER = "selectSecondFilter", t))(se || {});
class mr {
  constructor(e, r) {
    if (this.allFilterItems = [], !Array.isArray(e))
      throw new Error(`Array expected for allFilterItems. Received: ${typeof e}`);
    this.allFilterItems = e, r && (this.onChange = r);
  }
  getAvailableFilterItems(e) {
    return typeof (e == null ? void 0 : e.filterId) != "string" ? [...this.allFilterItems] : this.allFilterItems.filter((r) => r.filterId !== (e == null ? void 0 : e.filterId));
  }
  clearFirstFilter(e) {
    const r = { ...e };
    e.secondSelectedFilter ? (r.firstSelectedFilter = { ...e.secondSelectedFilter }, r.firstFilterItems = [...e.secondFilterItems], r.secondFilterItems = this.getAvailableFilterItems(r == null ? void 0 : r.firstSelectedFilter), r.secondSelectedFilter = void 0) : (r.firstFilterItems = [...this.allFilterItems], r.firstSelectedFilter = void 0);
    try {
      if (typeof this.onChange == "function") {
        const n = r != null && r.firstSelectedFilter ? [{ ...r == null ? void 0 : r.firstSelectedFilter }] : [];
        this.onChange({ filters: n });
      }
    } catch (n) {
      console.error(n);
    }
    return r;
  }
  clearSecondFilter(e) {
    const r = { ...e };
    r.secondSelectedFilter = void 0, r.secondFilterItems = this.getAvailableFilterItems(r == null ? void 0 : r.firstSelectedFilter);
    try {
      if (typeof this.onChange == "function") {
        const n = r != null && r.firstSelectedFilter ? [{ ...r == null ? void 0 : r.firstSelectedFilter }] : [];
        this.onChange({ filters: n });
      }
    } catch (n) {
      console.error(n);
    }
    return r;
  }
  selectFirstFilter(e, r) {
    var o;
    const n = { ...e }, { selectedFilterItem: i } = r;
    if (i) {
      const s = { ...i.item };
      (o = i == null ? void 0 : i.parentItem) != null && o.items && (n.firstFilterItems = i.parentItem.items, n.secondFilterItems = this.getAvailableFilterItems(s)), n.firstSelectedFilter = s;
      try {
        typeof this.onChange == "function" && this.onChange({ filters: [{ ...n.firstSelectedFilter }] });
      } catch (a) {
        console.error(a);
      }
    }
    return n;
  }
  selectSecondFilter(e, r) {
    var o;
    const n = { ...e }, { selectedFilterItem: i } = r;
    if (i) {
      const s = { ...i.item };
      (o = i == null ? void 0 : i.parentItem) != null && o.items && (n.secondFilterItems = i.parentItem.items), n.secondSelectedFilter = s;
      try {
        if (typeof this.onChange == "function") {
          const a = n != null && n.firstSelectedFilter ? [{ ...n == null ? void 0 : n.firstSelectedFilter }, { ...n.secondSelectedFilter }] : [{ ...n.secondSelectedFilter }];
          this.onChange({ filters: a });
        }
      } catch (a) {
        console.error(a);
      }
    }
    return n;
  }
}
function vr(t, e) {
  const { allFilterItems: r, onChange: n } = e.payload, i = new mr(r, n);
  switch (e.type) {
    case se.CLEAR_FIRST_FILTER:
      return i.clearFirstFilter(t);
    case se.CLEAR_SECOND_FILTER:
      return i.clearSecondFilter(t);
    case se.SELECT_FIRST_FILTER:
      return i.selectFirstFilter(t, e.payload);
    case se.SELECT_SECOND_FILTER:
      return i.selectSecondFilter(t, e.payload);
    default:
      throw new Error("Invalid action selected");
  }
}
function yr(t, e) {
  const [r, n] = Gt(vr, {
    firstFilterItems: [],
    secondFilterItems: [],
    firstSelectedFilter: void 0,
    secondSelectedFilter: void 0
  });
  function i() {
    n({
      type: "clearFirstFilter",
      payload: {
        allFilterItems: t,
        onChange: e
      }
    });
  }
  function o() {
    n({
      type: "clearSecondFilter",
      payload: {
        allFilterItems: t,
        onChange: e
      }
    });
  }
  function s(c) {
    n({
      type: "selectFirstFilter",
      payload: {
        allFilterItems: t,
        selectedFilterItem: c,
        onChange: e
      }
    });
  }
  function a(c) {
    n({
      type: "selectSecondFilter",
      payload: {
        allFilterItems: t,
        onChange: e,
        selectedFilterItem: c
      }
    });
  }
  return {
    state: r,
    clearFirstFilter: i,
    clearSecondFilter: o,
    selectFirstFilter: s,
    selectSecondFilter: a
  };
}
function bt(t) {
  const {
    biId: e,
    classes: r,
    filterListItems: n = [],
    onChange: i = () => ({}),
    placeholder: o,
    renderFirstFilter: s = (C) => /* @__PURE__ */ l.jsx(
      Ye,
      {
        ariaLabel: window.jQuery ? $.__("Item filter") : "Item filter",
        biId: e && `${e}-first-filter`,
        ...C
      }
    ),
    renderSecondFilter: a = (C) => /* @__PURE__ */ l.jsx(
      Ye,
      {
        ariaLabel: window.jQuery ? $.__("Additional item filter") : "Additional item filter",
        biId: e && `${e}-second-filter`,
        ...C
      }
    ),
    useSecondFilter: c = !1
  } = t, [u, f] = N(!1), { classes: p } = ar(void 0, { props: { classes: r } }), { clearFirstFilter: d, clearSecondFilter: h, selectFirstFilter: v, selectSecondFilter: m, state: S } = yr(n, i), { firstFilterItems: y, secondFilterItems: b, firstSelectedFilter: I, secondSelectedFilter: T } = S;
  return /* @__PURE__ */ l.jsxs("div", { className: p.root, children: [
    /* @__PURE__ */ l.jsx(l.Fragment, { children: typeof s == "function" && s({
      items: y.length > 0 ? y : n,
      onClear: () => {
        d(), f(!1);
      },
      onSelect: (C, D, O) => {
        v(O);
      },
      placeholder: o,
      selectedValues: I ? [I.value] : [],
      showSearch: "never",
      size: "small",
      width: u && y ? 4 : g.ifFeature("encore", 100, 6)
    }) }),
    c && typeof a == "function" && !!I && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
      !u && /* @__PURE__ */ l.jsx("div", { className: p.addFilterButtonContainer, children: /* @__PURE__ */ l.jsx(
        oe,
        {
          classes: {
            noBoundingBox: p.floatingIcon
          },
          icon: g.ifFeature("encore", "circle-plus-regular", /* @__PURE__ */ l.jsx(ht, {})),
          noBoundingBox: !0,
          onClick: () => {
            f(!0);
          },
          type: "button"
        }
      ) }),
      u && /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
        g.ifFeature(
          "encore",
          /* @__PURE__ */ l.jsx(B, { color: "neutral-medium", name: "plus-regular", size: 16 }),
          /* @__PURE__ */ l.jsx("div", { className: p.plusSelectIcon, children: "+" })
        ),
        /* @__PURE__ */ l.jsx(l.Fragment, { children: a({
          items: b,
          onClear: () => {
            f(!1), h();
          },
          onSelect: (C, D, O) => {
            m(O);
          },
          selectedValues: T ? [T.value] : [],
          showSearch: "never",
          size: "small",
          width: 4
        }) })
      ] })
    ] })
  ] });
}
const Sr = A()(({ constructs: t, palette: e, spacing: r, typography: n }) => ({
  noMatchFilter: g.ifFeature(
    "encore",
    {
      alignSelf: "center",
      color: t.text.neutral.medium,
      fontSize: n.medium.fontSize,
      fontWeight: n.fontWeightRegular,
      lineHeight: n.medium.lineHeight,
      margin: `auto ${r(7)}`,
      textAlign: "center"
    },
    {
      color: e.gray[700],
      fontSize: n.h4.fontSize,
      fontWeight: n.fontWeightBold,
      lineHeight: n.h4.lineHeight,
      marginTop: 40,
      padding: "0 20px",
      textAlign: "center"
    }
  ),
  transferListCenterColumn: {
    display: "flex",
    flexDirection: "column",
    height: 374,
    justifyContent: "center",
    minWidth: 80
  }
})), Ze = A()(({ spacing: t }) => ({
  transferListRoot: {
    alignItems: g.ifFeature("encore", "center"),
    boxSizing: "border-box",
    display: "flex",
    gap: g.ifFeature("encore", t(3))
  },
  transferListCenterColumn: {
    display: "flex",
    flexDirection: "column",
    height: 374,
    justifyContent: "center",
    minWidth: 24
  }
}));
var z = /* @__PURE__ */ ((t) => (t[t.MULTI_SELECT = 0] = "MULTI_SELECT", t[t.SINGLE_SELECT = 1] = "SINGLE_SELECT", t))(z || {}), L = /* @__PURE__ */ ((t) => (t[t.LEFT = 0] = "LEFT", t[t.RIGHT = 1] = "RIGHT", t))(L || {});
const br = (t, e) => {
  if (!e)
    return t && t.leftListItems ? t.leftListItems : [];
  const r = {};
  let n = [];
  return t && t.leftListItems && Array.isArray(t.leftListItems) && (n = te.cloneDeep(t.leftListItems), t.leftListItems.forEach((i) => {
    i.category && !r[i.category] && (r[i.category] = i.category);
  })), t && t.rightListItems && Array.isArray(t.rightListItems) && t.rightListItems.forEach((i) => {
    if (i.category && !r[i.category]) {
      const o = te.cloneDeep(i);
      o.subcategory = void 0, o.value = void 0, o.title = "", o.rowKey = "", o.children = void 0, n.push(o), r[i.category] = i.category;
    }
  }), n;
}, xt = Kt({
  dragDropManager: void 0
});
function j(t) {
  return "Minified Redux error #" + t + "; visit https://redux.js.org/Errors?code=" + t + " for the full message or use the non-minified dev environment for full errors. ";
}
var Je = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}(), Oe = function() {
  return Math.random().toString(36).substring(7).split("").join(".");
}, et = {
  INIT: "@@redux/INIT" + Oe(),
  REPLACE: "@@redux/REPLACE" + Oe(),
  PROBE_UNKNOWN_ACTION: function() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + Oe();
  }
};
function xr(t) {
  if (typeof t != "object" || t === null) return !1;
  for (var e = t; Object.getPrototypeOf(e) !== null; )
    e = Object.getPrototypeOf(e);
  return Object.getPrototypeOf(t) === e;
}
function Ct(t, e, r) {
  var n;
  if (typeof e == "function" && typeof r == "function" || typeof r == "function" && typeof arguments[3] == "function")
    throw new Error(j(0));
  if (typeof e == "function" && typeof r > "u" && (r = e, e = void 0), typeof r < "u") {
    if (typeof r != "function")
      throw new Error(j(1));
    return r(Ct)(t, e);
  }
  if (typeof t != "function")
    throw new Error(j(2));
  var i = t, o = e, s = [], a = s, c = !1;
  function u() {
    a === s && (a = s.slice());
  }
  function f() {
    if (c)
      throw new Error(j(3));
    return o;
  }
  function p(m) {
    if (typeof m != "function")
      throw new Error(j(4));
    if (c)
      throw new Error(j(5));
    var S = !0;
    return u(), a.push(m), function() {
      if (S) {
        if (c)
          throw new Error(j(6));
        S = !1, u();
        var b = a.indexOf(m);
        a.splice(b, 1), s = null;
      }
    };
  }
  function d(m) {
    if (!xr(m))
      throw new Error(j(7));
    if (typeof m.type > "u")
      throw new Error(j(8));
    if (c)
      throw new Error(j(9));
    try {
      c = !0, o = i(o, m);
    } finally {
      c = !1;
    }
    for (var S = s = a, y = 0; y < S.length; y++) {
      var b = S[y];
      b();
    }
    return m;
  }
  function h(m) {
    if (typeof m != "function")
      throw new Error(j(10));
    i = m, d({
      type: et.REPLACE
    });
  }
  function v() {
    var m, S = p;
    return m = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function(b) {
        if (typeof b != "object" || b === null)
          throw new Error(j(11));
        function I() {
          b.next && b.next(f());
        }
        I();
        var T = S(I);
        return {
          unsubscribe: T
        };
      }
    }, m[Je] = function() {
      return this;
    }, m;
  }
  return d({
    type: et.INIT
  }), n = {
    dispatch: d,
    subscribe: p,
    getState: f,
    replaceReducer: h
  }, n[Je] = v, n;
}
function x(t, e, ...r) {
  if (Cr() && e === void 0)
    throw new Error("invariant requires an error message argument");
  if (!t) {
    let n;
    if (e === void 0)
      n = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    else {
      let i = 0;
      n = new Error(e.replace(/%s/g, function() {
        return r[i++];
      })), n.name = "Invariant Violation";
    }
    throw n.framesToPop = 1, n;
  }
}
function Cr() {
  return typeof process < "u" && process.env.NODE_ENV === "production";
}
function Ir(t, e, r) {
  return e.split(".").reduce(
    (n, i) => n && n[i] ? n[i] : r || null,
    t
  );
}
function Dr(t, e) {
  return t.filter(
    (r) => r !== e
  );
}
function It(t) {
  return typeof t == "object";
}
function Tr(t, e) {
  const r = /* @__PURE__ */ new Map(), n = (o) => {
    r.set(o, r.has(o) ? r.get(o) + 1 : 1);
  };
  t.forEach(n), e.forEach(n);
  const i = [];
  return r.forEach((o, s) => {
    o === 1 && i.push(s);
  }), i;
}
function wr(t, e) {
  return t.filter(
    (r) => e.indexOf(r) > -1
  );
}
const Me = "dnd-core/INIT_COORDS", be = "dnd-core/BEGIN_DRAG", Be = "dnd-core/PUBLISH_DRAG_SOURCE", xe = "dnd-core/HOVER", Ce = "dnd-core/DROP", Ie = "dnd-core/END_DRAG";
function tt(t, e) {
  return {
    type: Me,
    payload: {
      sourceClientOffset: e || null,
      clientOffset: t || null
    }
  };
}
const Or = {
  type: Me,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function Er(t) {
  return function(r = [], n = {
    publishSource: !0
  }) {
    const { publishSource: i = !0, clientOffset: o, getSourceClientOffset: s } = n, a = t.getMonitor(), c = t.getRegistry();
    t.dispatch(tt(o)), Lr(r, a, c);
    const u = Nr(r, a);
    if (u == null) {
      t.dispatch(Or);
      return;
    }
    let f = null;
    if (o) {
      if (!s)
        throw new Error("getSourceClientOffset must be defined");
      Fr(s), f = s(u);
    }
    t.dispatch(tt(o, f));
    const d = c.getSource(u).beginDrag(a, u);
    if (d == null)
      return;
    Rr(d), c.pinSource(u);
    const h = c.getSourceType(u);
    return {
      type: be,
      payload: {
        itemType: h,
        item: d,
        sourceId: u,
        clientOffset: o || null,
        sourceClientOffset: f || null,
        isSourcePublic: !!i
      }
    };
  };
}
function Lr(t, e, r) {
  x(!e.isDragging(), "Cannot call beginDrag while dragging."), t.forEach(function(n) {
    x(r.getSource(n), "Expected sourceIds to be registered.");
  });
}
function Fr(t) {
  x(typeof t == "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function Rr(t) {
  x(It(t), "Item must be an object.");
}
function Nr(t, e) {
  let r = null;
  for (let n = t.length - 1; n >= 0; n--)
    if (e.canDragSource(t[n])) {
      r = t[n];
      break;
    }
  return r;
}
function Pr(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function jr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    }))), n.forEach(function(i) {
      Pr(t, i, r[i]);
    });
  }
  return t;
}
function kr(t) {
  return function(r = {}) {
    const n = t.getMonitor(), i = t.getRegistry();
    _r(n), $r(n).forEach((s, a) => {
      const c = Ar(s, a, i, n), u = {
        type: Ce,
        payload: {
          dropResult: jr({}, r, c)
        }
      };
      t.dispatch(u);
    });
  };
}
function _r(t) {
  x(t.isDragging(), "Cannot call drop while not dragging."), x(!t.didDrop(), "Cannot call drop twice during one drag operation.");
}
function Ar(t, e, r, n) {
  const i = r.getTarget(t);
  let o = i ? i.drop(n, t) : void 0;
  return Hr(o), typeof o > "u" && (o = e === 0 ? {} : n.getDropResult()), o;
}
function Hr(t) {
  x(typeof t > "u" || It(t), "Drop result must either be an object or undefined.");
}
function $r(t) {
  const e = t.getTargetIds().filter(t.canDropOnTarget, t);
  return e.reverse(), e;
}
function Mr(t) {
  return function() {
    const r = t.getMonitor(), n = t.getRegistry();
    Br(r);
    const i = r.getSourceId();
    return i != null && (n.getSource(i, !0).endDrag(r, i), n.unpinSource()), {
      type: Ie
    };
  };
}
function Br(t) {
  x(t.isDragging(), "Cannot call endDrag while not dragging.");
}
function je(t, e) {
  return e === null ? t === null : Array.isArray(t) ? t.some(
    (r) => r === e
  ) : t === e;
}
function zr(t) {
  return function(r, { clientOffset: n } = {}) {
    Wr(r);
    const i = r.slice(0), o = t.getMonitor(), s = t.getRegistry(), a = o.getItemType();
    return Gr(i, s, a), Ur(i, o, s), Kr(i, o, s), {
      type: xe,
      payload: {
        targetIds: i,
        clientOffset: n || null
      }
    };
  };
}
function Wr(t) {
  x(Array.isArray(t), "Expected targetIds to be an array.");
}
function Ur(t, e, r) {
  x(e.isDragging(), "Cannot call hover while not dragging."), x(!e.didDrop(), "Cannot call hover after drop.");
  for (let n = 0; n < t.length; n++) {
    const i = t[n];
    x(t.lastIndexOf(i) === n, "Expected targetIds to be unique in the passed array.");
    const o = r.getTarget(i);
    x(o, "Expected targetIds to be registered.");
  }
}
function Gr(t, e, r) {
  for (let n = t.length - 1; n >= 0; n--) {
    const i = t[n], o = e.getTargetType(i);
    je(o, r) || t.splice(n, 1);
  }
}
function Kr(t, e, r) {
  t.forEach(function(n) {
    r.getTarget(n).hover(e, n);
  });
}
function qr(t) {
  return function() {
    if (t.getMonitor().isDragging())
      return {
        type: Be
      };
  };
}
function Vr(t) {
  return {
    beginDrag: Er(t),
    publishDragSource: qr(t),
    hover: zr(t),
    drop: kr(t),
    endDrag: Mr(t)
  };
}
class Yr {
  receiveBackend(e) {
    this.backend = e;
  }
  getMonitor() {
    return this.monitor;
  }
  getBackend() {
    return this.backend;
  }
  getRegistry() {
    return this.monitor.registry;
  }
  getActions() {
    const e = this, { dispatch: r } = this.store;
    function n(o) {
      return (...s) => {
        const a = o.apply(e, s);
        typeof a < "u" && r(a);
      };
    }
    const i = Vr(this);
    return Object.keys(i).reduce((o, s) => {
      const a = i[s];
      return o[s] = n(a), o;
    }, {});
  }
  dispatch(e) {
    this.store.dispatch(e);
  }
  constructor(e, r) {
    this.isSetUp = !1, this.handleRefCountChange = () => {
      const n = this.store.getState().refCount > 0;
      this.backend && (n && !this.isSetUp ? (this.backend.setup(), this.isSetUp = !0) : !n && this.isSetUp && (this.backend.teardown(), this.isSetUp = !1));
    }, this.store = e, this.monitor = r, e.subscribe(this.handleRefCountChange);
  }
}
function Xr(t, e) {
  return {
    x: t.x + e.x,
    y: t.y + e.y
  };
}
function Dt(t, e) {
  return {
    x: t.x - e.x,
    y: t.y - e.y
  };
}
function Qr(t) {
  const { clientOffset: e, initialClientOffset: r, initialSourceClientOffset: n } = t;
  return !e || !r || !n ? null : Dt(Xr(e, n), r);
}
function Zr(t) {
  const { clientOffset: e, initialClientOffset: r } = t;
  return !e || !r ? null : Dt(e, r);
}
const ae = [], ze = [];
ae.__IS_NONE__ = !0;
ze.__IS_ALL__ = !0;
function Jr(t, e) {
  return t === ae ? !1 : t === ze || typeof e > "u" ? !0 : wr(e, t).length > 0;
}
class en {
  subscribeToStateChange(e, r = {}) {
    const { handlerIds: n } = r;
    x(typeof e == "function", "listener must be a function."), x(typeof n > "u" || Array.isArray(n), "handlerIds, when specified, must be an array of strings.");
    let i = this.store.getState().stateId;
    const o = () => {
      const s = this.store.getState(), a = s.stateId;
      try {
        a === i || a === i + 1 && !Jr(s.dirtyHandlerIds, n) || e();
      } finally {
        i = a;
      }
    };
    return this.store.subscribe(o);
  }
  subscribeToOffsetChange(e) {
    x(typeof e == "function", "listener must be a function.");
    let r = this.store.getState().dragOffset;
    const n = () => {
      const i = this.store.getState().dragOffset;
      i !== r && (r = i, e());
    };
    return this.store.subscribe(n);
  }
  canDragSource(e) {
    if (!e)
      return !1;
    const r = this.registry.getSource(e);
    return x(r, `Expected to find a valid source. sourceId=${e}`), this.isDragging() ? !1 : r.canDrag(this, e);
  }
  canDropOnTarget(e) {
    if (!e)
      return !1;
    const r = this.registry.getTarget(e);
    if (x(r, `Expected to find a valid target. targetId=${e}`), !this.isDragging() || this.didDrop())
      return !1;
    const n = this.registry.getTargetType(e), i = this.getItemType();
    return je(n, i) && r.canDrop(this, e);
  }
  isDragging() {
    return !!this.getItemType();
  }
  isDraggingSource(e) {
    if (!e)
      return !1;
    const r = this.registry.getSource(e, !0);
    if (x(r, `Expected to find a valid source. sourceId=${e}`), !this.isDragging() || !this.isSourcePublic())
      return !1;
    const n = this.registry.getSourceType(e), i = this.getItemType();
    return n !== i ? !1 : r.isDragging(this, e);
  }
  isOverTarget(e, r = {
    shallow: !1
  }) {
    if (!e)
      return !1;
    const { shallow: n } = r;
    if (!this.isDragging())
      return !1;
    const i = this.registry.getTargetType(e), o = this.getItemType();
    if (o && !je(i, o))
      return !1;
    const s = this.getTargetIds();
    if (!s.length)
      return !1;
    const a = s.indexOf(e);
    return n ? a === s.length - 1 : a > -1;
  }
  getItemType() {
    return this.store.getState().dragOperation.itemType;
  }
  getItem() {
    return this.store.getState().dragOperation.item;
  }
  getSourceId() {
    return this.store.getState().dragOperation.sourceId;
  }
  getTargetIds() {
    return this.store.getState().dragOperation.targetIds;
  }
  getDropResult() {
    return this.store.getState().dragOperation.dropResult;
  }
  didDrop() {
    return this.store.getState().dragOperation.didDrop;
  }
  isSourcePublic() {
    return !!this.store.getState().dragOperation.isSourcePublic;
  }
  getInitialClientOffset() {
    return this.store.getState().dragOffset.initialClientOffset;
  }
  getInitialSourceClientOffset() {
    return this.store.getState().dragOffset.initialSourceClientOffset;
  }
  getClientOffset() {
    return this.store.getState().dragOffset.clientOffset;
  }
  getSourceClientOffset() {
    return Qr(this.store.getState().dragOffset);
  }
  getDifferenceFromInitialOffset() {
    return Zr(this.store.getState().dragOffset);
  }
  constructor(e, r) {
    this.store = e, this.registry = r;
  }
}
const rt = typeof global < "u" ? global : self, Tt = rt.MutationObserver || rt.WebKitMutationObserver;
function wt(t) {
  return function() {
    const r = setTimeout(i, 0), n = setInterval(i, 50);
    function i() {
      clearTimeout(r), clearInterval(n), t();
    }
  };
}
function tn(t) {
  let e = 1;
  const r = new Tt(t), n = document.createTextNode("");
  return r.observe(n, {
    characterData: !0
  }), function() {
    e = -e, n.data = e;
  };
}
const rn = typeof Tt == "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  tn
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  wt
);
class nn {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(e) {
    const { queue: r, requestFlush: n } = this;
    r.length || (n(), this.flushing = !0), r[r.length] = e;
  }
  constructor() {
    this.queue = [], this.pendingErrors = [], this.flushing = !1, this.index = 0, this.capacity = 1024, this.flush = () => {
      const { queue: e } = this;
      for (; this.index < e.length; ) {
        const r = this.index;
        if (this.index++, e[r].call(), this.index > this.capacity) {
          for (let n = 0, i = e.length - this.index; n < i; n++)
            e[n] = e[n + this.index];
          e.length -= this.index, this.index = 0;
        }
      }
      e.length = 0, this.index = 0, this.flushing = !1;
    }, this.registerPendingError = (e) => {
      this.pendingErrors.push(e), this.requestErrorThrow();
    }, this.requestFlush = rn(this.flush), this.requestErrorThrow = wt(() => {
      if (this.pendingErrors.length)
        throw this.pendingErrors.shift();
    });
  }
}
class on {
  call() {
    try {
      this.task && this.task();
    } catch (e) {
      this.onError(e);
    } finally {
      this.task = null, this.release(this);
    }
  }
  constructor(e, r) {
    this.onError = e, this.release = r, this.task = null;
  }
}
class sn {
  create(e) {
    const r = this.freeTasks, n = r.length ? r.pop() : new on(
      this.onError,
      (i) => r[r.length] = i
    );
    return n.task = e, n;
  }
  constructor(e) {
    this.onError = e, this.freeTasks = [];
  }
}
const Ot = new nn(), an = new sn(Ot.registerPendingError);
function cn(t) {
  Ot.enqueueTask(an.create(t));
}
const We = "dnd-core/ADD_SOURCE", Ue = "dnd-core/ADD_TARGET", Ge = "dnd-core/REMOVE_SOURCE", De = "dnd-core/REMOVE_TARGET";
function ln(t) {
  return {
    type: We,
    payload: {
      sourceId: t
    }
  };
}
function un(t) {
  return {
    type: Ue,
    payload: {
      targetId: t
    }
  };
}
function dn(t) {
  return {
    type: Ge,
    payload: {
      sourceId: t
    }
  };
}
function fn(t) {
  return {
    type: De,
    payload: {
      targetId: t
    }
  };
}
function gn(t) {
  x(typeof t.canDrag == "function", "Expected canDrag to be a function."), x(typeof t.beginDrag == "function", "Expected beginDrag to be a function."), x(typeof t.endDrag == "function", "Expected endDrag to be a function.");
}
function hn(t) {
  x(typeof t.canDrop == "function", "Expected canDrop to be a function."), x(typeof t.hover == "function", "Expected hover to be a function."), x(typeof t.drop == "function", "Expected beginDrag to be a function.");
}
function ke(t, e) {
  if (e && Array.isArray(t)) {
    t.forEach(
      (r) => ke(r, !1)
    );
    return;
  }
  x(typeof t == "string" || typeof t == "symbol", e ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}
var k;
(function(t) {
  t.SOURCE = "SOURCE", t.TARGET = "TARGET";
})(k || (k = {}));
let pn = 0;
function mn() {
  return pn++;
}
function vn(t) {
  const e = mn().toString();
  switch (t) {
    case k.SOURCE:
      return `S${e}`;
    case k.TARGET:
      return `T${e}`;
    default:
      throw new Error(`Unknown Handler Role: ${t}`);
  }
}
function nt(t) {
  switch (t[0]) {
    case "S":
      return k.SOURCE;
    case "T":
      return k.TARGET;
    default:
      throw new Error(`Cannot parse handler ID: ${t}`);
  }
}
function it(t, e) {
  const r = t.entries();
  let n = !1;
  do {
    const { done: i, value: [, o] } = r.next();
    if (o === e)
      return !0;
    n = !!i;
  } while (!n);
  return !1;
}
class yn {
  addSource(e, r) {
    ke(e), gn(r);
    const n = this.addHandler(k.SOURCE, e, r);
    return this.store.dispatch(ln(n)), n;
  }
  addTarget(e, r) {
    ke(e, !0), hn(r);
    const n = this.addHandler(k.TARGET, e, r);
    return this.store.dispatch(un(n)), n;
  }
  containsHandler(e) {
    return it(this.dragSources, e) || it(this.dropTargets, e);
  }
  getSource(e, r = !1) {
    return x(this.isSourceId(e), "Expected a valid source ID."), r && e === this.pinnedSourceId ? this.pinnedSource : this.dragSources.get(e);
  }
  getTarget(e) {
    return x(this.isTargetId(e), "Expected a valid target ID."), this.dropTargets.get(e);
  }
  getSourceType(e) {
    return x(this.isSourceId(e), "Expected a valid source ID."), this.types.get(e);
  }
  getTargetType(e) {
    return x(this.isTargetId(e), "Expected a valid target ID."), this.types.get(e);
  }
  isSourceId(e) {
    return nt(e) === k.SOURCE;
  }
  isTargetId(e) {
    return nt(e) === k.TARGET;
  }
  removeSource(e) {
    x(this.getSource(e), "Expected an existing source."), this.store.dispatch(dn(e)), cn(() => {
      this.dragSources.delete(e), this.types.delete(e);
    });
  }
  removeTarget(e) {
    x(this.getTarget(e), "Expected an existing target."), this.store.dispatch(fn(e)), this.dropTargets.delete(e), this.types.delete(e);
  }
  pinSource(e) {
    const r = this.getSource(e);
    x(r, "Expected an existing source."), this.pinnedSourceId = e, this.pinnedSource = r;
  }
  unpinSource() {
    x(this.pinnedSource, "No source is pinned at the time."), this.pinnedSourceId = null, this.pinnedSource = null;
  }
  addHandler(e, r, n) {
    const i = vn(e);
    return this.types.set(i, r), e === k.SOURCE ? this.dragSources.set(i, n) : e === k.TARGET && this.dropTargets.set(i, n), i;
  }
  constructor(e) {
    this.types = /* @__PURE__ */ new Map(), this.dragSources = /* @__PURE__ */ new Map(), this.dropTargets = /* @__PURE__ */ new Map(), this.pinnedSourceId = null, this.pinnedSource = null, this.store = e;
  }
}
const Sn = (t, e) => t === e;
function bn(t, e) {
  return !t && !e ? !0 : !t || !e ? !1 : t.x === e.x && t.y === e.y;
}
function xn(t, e, r = Sn) {
  if (t.length !== e.length)
    return !1;
  for (let n = 0; n < t.length; ++n)
    if (!r(t[n], e[n]))
      return !1;
  return !0;
}
function Cn(t = ae, e) {
  switch (e.type) {
    case xe:
      break;
    case We:
    case Ue:
    case De:
    case Ge:
      return ae;
    case be:
    case Be:
    case Ie:
    case Ce:
    default:
      return ze;
  }
  const { targetIds: r = [], prevTargetIds: n = [] } = e.payload, i = Tr(r, n);
  if (!(i.length > 0 || !xn(r, n)))
    return ae;
  const s = n[n.length - 1], a = r[r.length - 1];
  return s !== a && (s && i.push(s), a && i.push(a)), i;
}
function In(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function Dn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    }))), n.forEach(function(i) {
      In(t, i, r[i]);
    });
  }
  return t;
}
const ot = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function Tn(t = ot, e) {
  const { payload: r } = e;
  switch (e.type) {
    case Me:
    case be:
      return {
        initialSourceClientOffset: r.sourceClientOffset,
        initialClientOffset: r.clientOffset,
        clientOffset: r.clientOffset
      };
    case xe:
      return bn(t.clientOffset, r.clientOffset) ? t : Dn({}, t, {
        clientOffset: r.clientOffset
      });
    case Ie:
    case Ce:
      return ot;
    default:
      return t;
  }
}
function wn(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function ee(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    }))), n.forEach(function(i) {
      wn(t, i, r[i]);
    });
  }
  return t;
}
const On = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: !1,
  isSourcePublic: null
};
function En(t = On, e) {
  const { payload: r } = e;
  switch (e.type) {
    case be:
      return ee({}, t, {
        itemType: r.itemType,
        item: r.item,
        sourceId: r.sourceId,
        isSourcePublic: r.isSourcePublic,
        dropResult: null,
        didDrop: !1
      });
    case Be:
      return ee({}, t, {
        isSourcePublic: !0
      });
    case xe:
      return ee({}, t, {
        targetIds: r.targetIds
      });
    case De:
      return t.targetIds.indexOf(r.targetId) === -1 ? t : ee({}, t, {
        targetIds: Dr(t.targetIds, r.targetId)
      });
    case Ce:
      return ee({}, t, {
        dropResult: r.dropResult,
        didDrop: !0,
        targetIds: []
      });
    case Ie:
      return ee({}, t, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: !1,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return t;
  }
}
function Ln(t = 0, e) {
  switch (e.type) {
    case We:
    case Ue:
      return t + 1;
    case Ge:
    case De:
      return t - 1;
    default:
      return t;
  }
}
function Fn(t = 0) {
  return t + 1;
}
function Rn(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function Nn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    }))), n.forEach(function(i) {
      Rn(t, i, r[i]);
    });
  }
  return t;
}
function Pn(t = {}, e) {
  return {
    dirtyHandlerIds: Cn(t.dirtyHandlerIds, {
      type: e.type,
      payload: Nn({}, e.payload, {
        prevTargetIds: Ir(t, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: Tn(t.dragOffset, e),
    refCount: Ln(t.refCount, e),
    dragOperation: En(t.dragOperation, e),
    stateId: Fn(t.stateId)
  };
}
function jn(t, e = void 0, r = {}, n = !1) {
  const i = kn(n), o = new en(i, new yn(i)), s = new Yr(i, o), a = t(s, e, r);
  return s.receiveBackend(a), s;
}
function kn(t) {
  const e = typeof window < "u" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return Ct(Pn, t && e && e({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}
function _n(t, e) {
  if (t == null) return {};
  var r = An(t, e), n, i;
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(t);
    for (i = 0; i < o.length; i++)
      n = o[i], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (r[n] = t[n]);
  }
  return r;
}
function An(t, e) {
  if (t == null) return {};
  var r = {}, n = Object.keys(t), i, o;
  for (o = 0; o < n.length; o++)
    i = n[o], !(e.indexOf(i) >= 0) && (r[i] = t[i]);
  return r;
}
let st = 0;
const pe = Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var Hn = /* @__PURE__ */ qt(function(e) {
  var { children: r } = e, n = _n(e, [
    "children"
  ]);
  const [i, o] = $n(n);
  return U(() => {
    if (o) {
      const s = Et();
      return ++st, () => {
        --st === 0 && (s[pe] = null);
      };
    }
  }, []), /* @__PURE__ */ l.jsx(xt.Provider, {
    value: i,
    children: r
  });
});
function $n(t) {
  if ("manager" in t)
    return [
      {
        dragDropManager: t.manager
      },
      !1
    ];
  const e = Mn(t.backend, t.context, t.options, t.debugMode), r = !t.context;
  return [
    e,
    r
  ];
}
function Mn(t, e = Et(), r, n) {
  const i = e;
  return i[pe] || (i[pe] = {
    dragDropManager: jn(t, e, r, n)
  }), i[pe];
}
function Et() {
  return typeof global < "u" ? global : window;
}
var Bn = function t(e, r) {
  if (e === r) return !0;
  if (e && r && typeof e == "object" && typeof r == "object") {
    if (e.constructor !== r.constructor) return !1;
    var n, i, o;
    if (Array.isArray(e)) {
      if (n = e.length, n != r.length) return !1;
      for (i = n; i-- !== 0; )
        if (!t(e[i], r[i])) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === r.source && e.flags === r.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === r.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === r.toString();
    if (o = Object.keys(e), n = o.length, n !== Object.keys(r).length) return !1;
    for (i = n; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(r, o[i])) return !1;
    for (i = n; i-- !== 0; ) {
      var s = o[i];
      if (!t(e[s], r[s])) return !1;
    }
    return !0;
  }
  return e !== e && r !== r;
};
const zn = /* @__PURE__ */ nr(Bn), q = typeof window < "u" ? Vt : U;
function Wn(t, e, r) {
  const [n, i] = N(
    () => e(t)
  ), o = ce(() => {
    const s = e(t);
    zn(n, s) || (i(s), r && r());
  }, [
    n,
    t,
    r
  ]);
  return q(o), [
    n,
    o
  ];
}
function Un(t, e, r) {
  const [n, i] = Wn(t, e, r);
  return q(function() {
    const s = t.getHandlerId();
    if (s != null)
      return t.subscribeToStateChange(i, {
        handlerIds: [
          s
        ]
      });
  }, [
    t,
    i
  ]), n;
}
function Lt(t, e, r) {
  return Un(
    e,
    t || (() => ({})),
    () => r.reconnect()
  );
}
function Ft(t, e) {
  const r = [];
  return typeof t != "function" && r.push(t), _(() => typeof t == "function" ? t() : t, r);
}
function Gn(t) {
  return _(
    () => t.hooks.dragSource(),
    [
      t
    ]
  );
}
function Kn(t) {
  return _(
    () => t.hooks.dragPreview(),
    [
      t
    ]
  );
}
let Ee = !1, Le = !1;
class qn {
  receiveHandlerId(e) {
    this.sourceId = e;
  }
  getHandlerId() {
    return this.sourceId;
  }
  canDrag() {
    x(!Ee, "You may not call monitor.canDrag() inside your canDrag() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return Ee = !0, this.internalMonitor.canDragSource(this.sourceId);
    } finally {
      Ee = !1;
    }
  }
  isDragging() {
    if (!this.sourceId)
      return !1;
    x(!Le, "You may not call monitor.isDragging() inside your isDragging() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drag-source-monitor");
    try {
      return Le = !0, this.internalMonitor.isDraggingSource(this.sourceId);
    } finally {
      Le = !1;
    }
  }
  subscribeToStateChange(e, r) {
    return this.internalMonitor.subscribeToStateChange(e, r);
  }
  isDraggingSource(e) {
    return this.internalMonitor.isDraggingSource(e);
  }
  isOverTarget(e, r) {
    return this.internalMonitor.isOverTarget(e, r);
  }
  getTargetIds() {
    return this.internalMonitor.getTargetIds();
  }
  isSourcePublic() {
    return this.internalMonitor.isSourcePublic();
  }
  getSourceId() {
    return this.internalMonitor.getSourceId();
  }
  subscribeToOffsetChange(e) {
    return this.internalMonitor.subscribeToOffsetChange(e);
  }
  canDragSource(e) {
    return this.internalMonitor.canDragSource(e);
  }
  canDropOnTarget(e) {
    return this.internalMonitor.canDropOnTarget(e);
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(e) {
    this.sourceId = null, this.internalMonitor = e.getMonitor();
  }
}
let Fe = !1;
class Vn {
  receiveHandlerId(e) {
    this.targetId = e;
  }
  getHandlerId() {
    return this.targetId;
  }
  subscribeToStateChange(e, r) {
    return this.internalMonitor.subscribeToStateChange(e, r);
  }
  canDrop() {
    if (!this.targetId)
      return !1;
    x(!Fe, "You may not call monitor.canDrop() inside your canDrop() implementation. Read more: http://react-dnd.github.io/react-dnd/docs/api/drop-target-monitor");
    try {
      return Fe = !0, this.internalMonitor.canDropOnTarget(this.targetId);
    } finally {
      Fe = !1;
    }
  }
  isOver(e) {
    return this.targetId ? this.internalMonitor.isOverTarget(this.targetId, e) : !1;
  }
  getItemType() {
    return this.internalMonitor.getItemType();
  }
  getItem() {
    return this.internalMonitor.getItem();
  }
  getDropResult() {
    return this.internalMonitor.getDropResult();
  }
  didDrop() {
    return this.internalMonitor.didDrop();
  }
  getInitialClientOffset() {
    return this.internalMonitor.getInitialClientOffset();
  }
  getInitialSourceClientOffset() {
    return this.internalMonitor.getInitialSourceClientOffset();
  }
  getSourceClientOffset() {
    return this.internalMonitor.getSourceClientOffset();
  }
  getClientOffset() {
    return this.internalMonitor.getClientOffset();
  }
  getDifferenceFromInitialOffset() {
    return this.internalMonitor.getDifferenceFromInitialOffset();
  }
  constructor(e) {
    this.targetId = null, this.internalMonitor = e.getMonitor();
  }
}
function Yn(t, e, r) {
  const n = r.getRegistry(), i = n.addTarget(t, e);
  return [
    i,
    () => n.removeTarget(i)
  ];
}
function Xn(t, e, r) {
  const n = r.getRegistry(), i = n.addSource(t, e);
  return [
    i,
    () => n.removeSource(i)
  ];
}
function _e(t, e, r, n) {
  let i;
  if (i !== void 0)
    return !!i;
  if (t === e)
    return !0;
  if (typeof t != "object" || !t || typeof e != "object" || !e)
    return !1;
  const o = Object.keys(t), s = Object.keys(e);
  if (o.length !== s.length)
    return !1;
  const a = Object.prototype.hasOwnProperty.bind(e);
  for (let c = 0; c < o.length; c++) {
    const u = o[c];
    if (!a(u))
      return !1;
    const f = t[u], p = e[u];
    if (i = void 0, i === !1 || i === void 0 && f !== p)
      return !1;
  }
  return !0;
}
function Ae(t) {
  return (
    // eslint-disable-next-line no-prototype-builtins
    t !== null && typeof t == "object" && Object.prototype.hasOwnProperty.call(t, "current")
  );
}
function Qn(t) {
  if (typeof t.type == "string")
    return;
  const e = t.type.displayName || t.type.name || "the component";
  throw new Error(`Only native element nodes can now be passed to React DnD connectors.You can either wrap ${e} into a <div>, or turn it into a drag source or a drop target itself.`);
}
function Zn(t) {
  return (e = null, r = null) => {
    if (!Yt(e)) {
      const o = e;
      return t(o, r), o;
    }
    const n = e;
    return Qn(n), Jn(n, r ? (o) => t(o, r) : t);
  };
}
function Rt(t) {
  const e = {};
  return Object.keys(t).forEach((r) => {
    const n = t[r];
    if (r.endsWith("Ref"))
      e[r] = t[r];
    else {
      const i = Zn(n);
      e[r] = () => i;
    }
  }), e;
}
function at(t, e) {
  typeof t == "function" ? t(e) : t.current = e;
}
function Jn(t, e) {
  const r = t.ref;
  return x(typeof r != "string", "Cannot connect React DnD to an element with an existing string ref. Please convert it to use a callback ref instead, or wrap it into a <span> or <div>. Read more: https://reactjs.org/docs/refs-and-the-dom.html#callback-refs"), r ? Ve(t, {
    ref: (n) => {
      at(r, n), at(e, n);
    }
  }) : Ve(t, {
    ref: e
  });
}
class ei {
  receiveHandlerId(e) {
    this.handlerId !== e && (this.handlerId = e, this.reconnect());
  }
  get connectTarget() {
    return this.dragSource;
  }
  get dragSourceOptions() {
    return this.dragSourceOptionsInternal;
  }
  set dragSourceOptions(e) {
    this.dragSourceOptionsInternal = e;
  }
  get dragPreviewOptions() {
    return this.dragPreviewOptionsInternal;
  }
  set dragPreviewOptions(e) {
    this.dragPreviewOptionsInternal = e;
  }
  reconnect() {
    const e = this.reconnectDragSource();
    this.reconnectDragPreview(e);
  }
  reconnectDragSource() {
    const e = this.dragSource, r = this.didHandlerIdChange() || this.didConnectedDragSourceChange() || this.didDragSourceOptionsChange();
    return r && this.disconnectDragSource(), this.handlerId ? e ? (r && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragSource = e, this.lastConnectedDragSourceOptions = this.dragSourceOptions, this.dragSourceUnsubscribe = this.backend.connectDragSource(this.handlerId, e, this.dragSourceOptions)), r) : (this.lastConnectedDragSource = e, r) : r;
  }
  reconnectDragPreview(e = !1) {
    const r = this.dragPreview, n = e || this.didHandlerIdChange() || this.didConnectedDragPreviewChange() || this.didDragPreviewOptionsChange();
    if (n && this.disconnectDragPreview(), !!this.handlerId) {
      if (!r) {
        this.lastConnectedDragPreview = r;
        return;
      }
      n && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDragPreview = r, this.lastConnectedDragPreviewOptions = this.dragPreviewOptions, this.dragPreviewUnsubscribe = this.backend.connectDragPreview(this.handlerId, r, this.dragPreviewOptions));
    }
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didConnectedDragSourceChange() {
    return this.lastConnectedDragSource !== this.dragSource;
  }
  didConnectedDragPreviewChange() {
    return this.lastConnectedDragPreview !== this.dragPreview;
  }
  didDragSourceOptionsChange() {
    return !_e(this.lastConnectedDragSourceOptions, this.dragSourceOptions);
  }
  didDragPreviewOptionsChange() {
    return !_e(this.lastConnectedDragPreviewOptions, this.dragPreviewOptions);
  }
  disconnectDragSource() {
    this.dragSourceUnsubscribe && (this.dragSourceUnsubscribe(), this.dragSourceUnsubscribe = void 0);
  }
  disconnectDragPreview() {
    this.dragPreviewUnsubscribe && (this.dragPreviewUnsubscribe(), this.dragPreviewUnsubscribe = void 0, this.dragPreviewNode = null, this.dragPreviewRef = null);
  }
  get dragSource() {
    return this.dragSourceNode || this.dragSourceRef && this.dragSourceRef.current;
  }
  get dragPreview() {
    return this.dragPreviewNode || this.dragPreviewRef && this.dragPreviewRef.current;
  }
  clearDragSource() {
    this.dragSourceNode = null, this.dragSourceRef = null;
  }
  clearDragPreview() {
    this.dragPreviewNode = null, this.dragPreviewRef = null;
  }
  constructor(e) {
    this.hooks = Rt({
      dragSource: (r, n) => {
        this.clearDragSource(), this.dragSourceOptions = n || null, Ae(r) ? this.dragSourceRef = r : this.dragSourceNode = r, this.reconnectDragSource();
      },
      dragPreview: (r, n) => {
        this.clearDragPreview(), this.dragPreviewOptions = n || null, Ae(r) ? this.dragPreviewRef = r : this.dragPreviewNode = r, this.reconnectDragPreview();
      }
    }), this.handlerId = null, this.dragSourceRef = null, this.dragSourceOptionsInternal = null, this.dragPreviewRef = null, this.dragPreviewOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDragSource = null, this.lastConnectedDragSourceOptions = null, this.lastConnectedDragPreview = null, this.lastConnectedDragPreviewOptions = null, this.backend = e;
  }
}
class ti {
  get connectTarget() {
    return this.dropTarget;
  }
  reconnect() {
    const e = this.didHandlerIdChange() || this.didDropTargetChange() || this.didOptionsChange();
    e && this.disconnectDropTarget();
    const r = this.dropTarget;
    if (this.handlerId) {
      if (!r) {
        this.lastConnectedDropTarget = r;
        return;
      }
      e && (this.lastConnectedHandlerId = this.handlerId, this.lastConnectedDropTarget = r, this.lastConnectedDropTargetOptions = this.dropTargetOptions, this.unsubscribeDropTarget = this.backend.connectDropTarget(this.handlerId, r, this.dropTargetOptions));
    }
  }
  receiveHandlerId(e) {
    e !== this.handlerId && (this.handlerId = e, this.reconnect());
  }
  get dropTargetOptions() {
    return this.dropTargetOptionsInternal;
  }
  set dropTargetOptions(e) {
    this.dropTargetOptionsInternal = e;
  }
  didHandlerIdChange() {
    return this.lastConnectedHandlerId !== this.handlerId;
  }
  didDropTargetChange() {
    return this.lastConnectedDropTarget !== this.dropTarget;
  }
  didOptionsChange() {
    return !_e(this.lastConnectedDropTargetOptions, this.dropTargetOptions);
  }
  disconnectDropTarget() {
    this.unsubscribeDropTarget && (this.unsubscribeDropTarget(), this.unsubscribeDropTarget = void 0);
  }
  get dropTarget() {
    return this.dropTargetNode || this.dropTargetRef && this.dropTargetRef.current;
  }
  clearDropTarget() {
    this.dropTargetRef = null, this.dropTargetNode = null;
  }
  constructor(e) {
    this.hooks = Rt({
      dropTarget: (r, n) => {
        this.clearDropTarget(), this.dropTargetOptions = n, Ae(r) ? this.dropTargetRef = r : this.dropTargetNode = r, this.reconnect();
      }
    }), this.handlerId = null, this.dropTargetRef = null, this.dropTargetOptionsInternal = null, this.lastConnectedHandlerId = null, this.lastConnectedDropTarget = null, this.lastConnectedDropTargetOptions = null, this.backend = e;
  }
}
function re() {
  const { dragDropManager: t } = Xt(xt);
  return x(t != null, "Expected drag drop context"), t;
}
function ri(t, e) {
  const r = re(), n = _(
    () => new ei(r.getBackend()),
    [
      r
    ]
  );
  return q(() => (n.dragSourceOptions = t || null, n.reconnect(), () => n.disconnectDragSource()), [
    n,
    t
  ]), q(() => (n.dragPreviewOptions = e || null, n.reconnect(), () => n.disconnectDragPreview()), [
    n,
    e
  ]), n;
}
function ni() {
  const t = re();
  return _(
    () => new qn(t),
    [
      t
    ]
  );
}
class ii {
  beginDrag() {
    const e = this.spec, r = this.monitor;
    let n = null;
    return typeof e.item == "object" ? n = e.item : typeof e.item == "function" ? n = e.item(r) : n = {}, n ?? null;
  }
  canDrag() {
    const e = this.spec, r = this.monitor;
    return typeof e.canDrag == "boolean" ? e.canDrag : typeof e.canDrag == "function" ? e.canDrag(r) : !0;
  }
  isDragging(e, r) {
    const n = this.spec, i = this.monitor, { isDragging: o } = n;
    return o ? o(i) : r === e.getSourceId();
  }
  endDrag() {
    const e = this.spec, r = this.monitor, n = this.connector, { end: i } = e;
    i && i(r.getItem(), r), n.reconnect();
  }
  constructor(e, r, n) {
    this.spec = e, this.monitor = r, this.connector = n;
  }
}
function oi(t, e, r) {
  const n = _(
    () => new ii(t, e, r),
    [
      e,
      r
    ]
  );
  return U(() => {
    n.spec = t;
  }, [
    t
  ]), n;
}
function si(t) {
  return _(() => {
    const e = t.type;
    return x(e != null, "spec.type must be defined"), e;
  }, [
    t
  ]);
}
function ai(t, e, r) {
  const n = re(), i = oi(t, e, r), o = si(t);
  q(function() {
    if (o != null) {
      const [a, c] = Xn(o, i, n);
      return e.receiveHandlerId(a), r.receiveHandlerId(a), c;
    }
  }, [
    n,
    e,
    r,
    i,
    o
  ]);
}
function Nt(t, e) {
  const r = Ft(t);
  x(!r.begin, "useDrag::spec.begin was deprecated in v14. Replace spec.begin() with spec.item(). (see more here - https://react-dnd.github.io/react-dnd/docs/api/use-drag)");
  const n = ni(), i = ri(r.options, r.previewOptions);
  return ai(r, n, i), [
    Lt(r.collect, n, i),
    Gn(i),
    Kn(i)
  ];
}
function ci(t) {
  return _(
    () => t.hooks.dropTarget(),
    [
      t
    ]
  );
}
function li(t) {
  const e = re(), r = _(
    () => new ti(e.getBackend()),
    [
      e
    ]
  );
  return q(() => (r.dropTargetOptions = t || null, r.reconnect(), () => r.disconnectDropTarget()), [
    t
  ]), r;
}
function ui() {
  const t = re();
  return _(
    () => new Vn(t),
    [
      t
    ]
  );
}
function di(t) {
  const { accept: e } = t;
  return _(() => (x(t.accept != null, "accept must be defined"), Array.isArray(e) ? e : [
    e
  ]), [
    e
  ]);
}
class fi {
  canDrop() {
    const e = this.spec, r = this.monitor;
    return e.canDrop ? e.canDrop(r.getItem(), r) : !0;
  }
  hover() {
    const e = this.spec, r = this.monitor;
    e.hover && e.hover(r.getItem(), r);
  }
  drop() {
    const e = this.spec, r = this.monitor;
    if (e.drop)
      return e.drop(r.getItem(), r);
  }
  constructor(e, r) {
    this.spec = e, this.monitor = r;
  }
}
function gi(t, e) {
  const r = _(
    () => new fi(t, e),
    [
      e
    ]
  );
  return U(() => {
    r.spec = t;
  }, [
    t
  ]), r;
}
function hi(t, e, r) {
  const n = re(), i = gi(t, e), o = di(t);
  q(function() {
    const [a, c] = Yn(o, i, n);
    return e.receiveHandlerId(a), r.receiveHandlerId(a), c;
  }, [
    n,
    e,
    i,
    r,
    o.map(
      (s) => s.toString()
    ).join("|")
  ]);
}
function Pt(t, e) {
  const r = Ft(t), n = ui(), i = li(r.options);
  return hi(r, n, i), [
    Lt(r.collect, n, i),
    ci(i)
  ];
}
function jt(t) {
  let e = null;
  return () => (e == null && (e = t()), e);
}
function pi(t, e) {
  return t.filter(
    (r) => r !== e
  );
}
function mi(t, e) {
  const r = /* @__PURE__ */ new Set(), n = (o) => r.add(o);
  t.forEach(n), e.forEach(n);
  const i = [];
  return r.forEach(
    (o) => i.push(o)
  ), i;
}
class vi {
  enter(e) {
    const r = this.entered.length, n = (i) => this.isNodeInDocument(i) && (!i.contains || i.contains(e));
    return this.entered = mi(this.entered.filter(n), [
      e
    ]), r === 0 && this.entered.length > 0;
  }
  leave(e) {
    const r = this.entered.length;
    return this.entered = pi(this.entered.filter(this.isNodeInDocument), e), r > 0 && this.entered.length === 0;
  }
  reset() {
    this.entered = [];
  }
  constructor(e) {
    this.entered = [], this.isNodeInDocument = e;
  }
}
class yi {
  initializeExposedProperties() {
    Object.keys(this.config.exposeProperties).forEach((e) => {
      Object.defineProperty(this.item, e, {
        configurable: !0,
        enumerable: !0,
        get() {
          return console.warn(`Browser doesn't allow reading "${e}" until the drop event.`), null;
        }
      });
    });
  }
  loadDataTransfer(e) {
    if (e) {
      const r = {};
      Object.keys(this.config.exposeProperties).forEach((n) => {
        const i = this.config.exposeProperties[n];
        i != null && (r[n] = {
          value: i(e, this.config.matchesTypes),
          configurable: !0,
          enumerable: !0
        });
      }), Object.defineProperties(this.item, r);
    }
  }
  canDrag() {
    return !0;
  }
  beginDrag() {
    return this.item;
  }
  isDragging(e, r) {
    return r === e.getSourceId();
  }
  endDrag() {
  }
  constructor(e) {
    this.config = e, this.item = {}, this.initializeExposedProperties();
  }
}
const kt = "__NATIVE_FILE__", _t = "__NATIVE_URL__", At = "__NATIVE_TEXT__", Ht = "__NATIVE_HTML__", ct = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  FILE: kt,
  HTML: Ht,
  TEXT: At,
  URL: _t
}, Symbol.toStringTag, { value: "Module" }));
function Re(t, e, r) {
  const n = e.reduce(
    (i, o) => i || t.getData(o),
    ""
  );
  return n ?? r;
}
const He = {
  [kt]: {
    exposeProperties: {
      files: (t) => Array.prototype.slice.call(t.files),
      items: (t) => t.items,
      dataTransfer: (t) => t
    },
    matchesTypes: [
      "Files"
    ]
  },
  [Ht]: {
    exposeProperties: {
      html: (t, e) => Re(t, e, ""),
      dataTransfer: (t) => t
    },
    matchesTypes: [
      "Html",
      "text/html"
    ]
  },
  [_t]: {
    exposeProperties: {
      urls: (t, e) => Re(t, e, "").split(`
`),
      dataTransfer: (t) => t
    },
    matchesTypes: [
      "Url",
      "text/uri-list"
    ]
  },
  [At]: {
    exposeProperties: {
      text: (t, e) => Re(t, e, ""),
      dataTransfer: (t) => t
    },
    matchesTypes: [
      "Text",
      "text/plain"
    ]
  }
};
function Si(t, e) {
  const r = He[t];
  if (!r)
    throw new Error(`native type ${t} has no configuration`);
  const n = new yi(r);
  return n.loadDataTransfer(e), n;
}
function Ne(t) {
  if (!t)
    return null;
  const e = Array.prototype.slice.call(t.types || []);
  return Object.keys(He).filter((r) => {
    const n = He[r];
    return n != null && n.matchesTypes ? n.matchesTypes.some(
      (i) => e.indexOf(i) > -1
    ) : !1;
  })[0] || null;
}
const bi = jt(
  () => /firefox/i.test(navigator.userAgent)
), $t = jt(
  () => !!window.safari
);
class lt {
  interpolate(e) {
    const { xs: r, ys: n, c1s: i, c2s: o, c3s: s } = this;
    let a = r.length - 1;
    if (e === r[a])
      return n[a];
    let c = 0, u = s.length - 1, f;
    for (; c <= u; ) {
      f = Math.floor(0.5 * (c + u));
      const h = r[f];
      if (h < e)
        c = f + 1;
      else if (h > e)
        u = f - 1;
      else
        return n[f];
    }
    a = Math.max(0, u);
    const p = e - r[a], d = p * p;
    return n[a] + i[a] * p + o[a] * d + s[a] * p * d;
  }
  constructor(e, r) {
    const { length: n } = e, i = [];
    for (let h = 0; h < n; h++)
      i.push(h);
    i.sort(
      (h, v) => e[h] < e[v] ? -1 : 1
    );
    const o = [], s = [];
    let a, c;
    for (let h = 0; h < n - 1; h++)
      a = e[h + 1] - e[h], c = r[h + 1] - r[h], o.push(a), s.push(c / a);
    const u = [
      s[0]
    ];
    for (let h = 0; h < o.length - 1; h++) {
      const v = s[h], m = s[h + 1];
      if (v * m <= 0)
        u.push(0);
      else {
        a = o[h];
        const S = o[h + 1], y = a + S;
        u.push(3 * y / ((y + S) / v + (y + a) / m));
      }
    }
    u.push(s[s.length - 1]);
    const f = [], p = [];
    let d;
    for (let h = 0; h < u.length - 1; h++) {
      d = s[h];
      const v = u[h], m = 1 / o[h], S = v + u[h + 1] - d - d;
      f.push((d - v - S) * m), p.push(S * m * m);
    }
    this.xs = e, this.ys = r, this.c1s = u, this.c2s = f, this.c3s = p;
  }
}
const xi = 1;
function Mt(t) {
  const e = t.nodeType === xi ? t : t.parentElement;
  if (!e)
    return null;
  const { top: r, left: n } = e.getBoundingClientRect();
  return {
    x: n,
    y: r
  };
}
function he(t) {
  return {
    x: t.clientX,
    y: t.clientY
  };
}
function Ci(t) {
  var e;
  return t.nodeName === "IMG" && (bi() || !(!((e = document.documentElement) === null || e === void 0) && e.contains(t)));
}
function Ii(t, e, r, n) {
  let i = t ? e.width : r, o = t ? e.height : n;
  return $t() && t && (o /= window.devicePixelRatio, i /= window.devicePixelRatio), {
    dragPreviewWidth: i,
    dragPreviewHeight: o
  };
}
function Di(t, e, r, n, i) {
  const o = Ci(e), a = Mt(o ? t : e), c = {
    x: r.x - a.x,
    y: r.y - a.y
  }, { offsetWidth: u, offsetHeight: f } = t, { anchorX: p, anchorY: d } = n, { dragPreviewWidth: h, dragPreviewHeight: v } = Ii(o, e, u, f), m = () => {
    let D = new lt([
      0,
      0.5,
      1
    ], [
      // Dock to the top
      c.y,
      // Align at the center
      c.y / f * v,
      // Dock to the bottom
      c.y + v - f
    ]).interpolate(d);
    return $t() && o && (D += (window.devicePixelRatio - 1) * v), D;
  }, S = () => new lt([
    0,
    0.5,
    1
  ], [
    // Dock to the left
    c.x,
    // Align at the center
    c.x / u * h,
    // Dock to the right
    c.x + h - u
  ]).interpolate(p), { offsetX: y, offsetY: b } = i, I = y === 0 || y, T = b === 0 || b;
  return {
    x: I ? y : S(),
    y: T ? b : m()
  };
}
class Ti {
  get window() {
    if (this.globalContext)
      return this.globalContext;
    if (typeof window < "u")
      return window;
  }
  get document() {
    var e;
    return !((e = this.globalContext) === null || e === void 0) && e.document ? this.globalContext.document : this.window ? this.window.document : void 0;
  }
  get rootElement() {
    var e;
    return ((e = this.optionsArgs) === null || e === void 0 ? void 0 : e.rootElement) || this.window;
  }
  constructor(e, r) {
    this.ownerDocument = null, this.globalContext = e, this.optionsArgs = r;
  }
}
function wi(t, e, r) {
  return e in t ? Object.defineProperty(t, e, {
    value: r,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = r, t;
}
function ut(t) {
  for (var e = 1; e < arguments.length; e++) {
    var r = arguments[e] != null ? arguments[e] : {}, n = Object.keys(r);
    typeof Object.getOwnPropertySymbols == "function" && (n = n.concat(Object.getOwnPropertySymbols(r).filter(function(i) {
      return Object.getOwnPropertyDescriptor(r, i).enumerable;
    }))), n.forEach(function(i) {
      wi(t, i, r[i]);
    });
  }
  return t;
}
class Oi {
  /**
  * Generate profiling statistics for the HTML5Backend.
  */
  profile() {
    var e, r;
    return {
      sourcePreviewNodes: this.sourcePreviewNodes.size,
      sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
      sourceNodeOptions: this.sourceNodeOptions.size,
      sourceNodes: this.sourceNodes.size,
      dragStartSourceIds: ((e = this.dragStartSourceIds) === null || e === void 0 ? void 0 : e.length) || 0,
      dropTargetIds: this.dropTargetIds.length,
      dragEnterTargetIds: this.dragEnterTargetIds.length,
      dragOverTargetIds: ((r = this.dragOverTargetIds) === null || r === void 0 ? void 0 : r.length) || 0
    };
  }
  // public for test
  get window() {
    return this.options.window;
  }
  get document() {
    return this.options.document;
  }
  /**
  * Get the root element to use for event subscriptions
  */
  get rootElement() {
    return this.options.rootElement;
  }
  setup() {
    const e = this.rootElement;
    if (e !== void 0) {
      if (e.__isReactDndBackendSetUp)
        throw new Error("Cannot have two HTML5 backends at the same time.");
      e.__isReactDndBackendSetUp = !0, this.addEventListeners(e);
    }
  }
  teardown() {
    const e = this.rootElement;
    if (e !== void 0 && (e.__isReactDndBackendSetUp = !1, this.removeEventListeners(this.rootElement), this.clearCurrentDragSourceNode(), this.asyncEndDragFrameId)) {
      var r;
      (r = this.window) === null || r === void 0 || r.cancelAnimationFrame(this.asyncEndDragFrameId);
    }
  }
  connectDragPreview(e, r, n) {
    return this.sourcePreviewNodeOptions.set(e, n), this.sourcePreviewNodes.set(e, r), () => {
      this.sourcePreviewNodes.delete(e), this.sourcePreviewNodeOptions.delete(e);
    };
  }
  connectDragSource(e, r, n) {
    this.sourceNodes.set(e, r), this.sourceNodeOptions.set(e, n);
    const i = (s) => this.handleDragStart(s, e), o = (s) => this.handleSelectStart(s);
    return r.setAttribute("draggable", "true"), r.addEventListener("dragstart", i), r.addEventListener("selectstart", o), () => {
      this.sourceNodes.delete(e), this.sourceNodeOptions.delete(e), r.removeEventListener("dragstart", i), r.removeEventListener("selectstart", o), r.setAttribute("draggable", "false");
    };
  }
  connectDropTarget(e, r) {
    const n = (s) => this.handleDragEnter(s, e), i = (s) => this.handleDragOver(s, e), o = (s) => this.handleDrop(s, e);
    return r.addEventListener("dragenter", n), r.addEventListener("dragover", i), r.addEventListener("drop", o), () => {
      r.removeEventListener("dragenter", n), r.removeEventListener("dragover", i), r.removeEventListener("drop", o);
    };
  }
  addEventListeners(e) {
    e.addEventListener && (e.addEventListener("dragstart", this.handleTopDragStart), e.addEventListener("dragstart", this.handleTopDragStartCapture, !0), e.addEventListener("dragend", this.handleTopDragEndCapture, !0), e.addEventListener("dragenter", this.handleTopDragEnter), e.addEventListener("dragenter", this.handleTopDragEnterCapture, !0), e.addEventListener("dragleave", this.handleTopDragLeaveCapture, !0), e.addEventListener("dragover", this.handleTopDragOver), e.addEventListener("dragover", this.handleTopDragOverCapture, !0), e.addEventListener("drop", this.handleTopDrop), e.addEventListener("drop", this.handleTopDropCapture, !0));
  }
  removeEventListeners(e) {
    e.removeEventListener && (e.removeEventListener("dragstart", this.handleTopDragStart), e.removeEventListener("dragstart", this.handleTopDragStartCapture, !0), e.removeEventListener("dragend", this.handleTopDragEndCapture, !0), e.removeEventListener("dragenter", this.handleTopDragEnter), e.removeEventListener("dragenter", this.handleTopDragEnterCapture, !0), e.removeEventListener("dragleave", this.handleTopDragLeaveCapture, !0), e.removeEventListener("dragover", this.handleTopDragOver), e.removeEventListener("dragover", this.handleTopDragOverCapture, !0), e.removeEventListener("drop", this.handleTopDrop), e.removeEventListener("drop", this.handleTopDropCapture, !0));
  }
  getCurrentSourceNodeOptions() {
    const e = this.monitor.getSourceId(), r = this.sourceNodeOptions.get(e);
    return ut({
      dropEffect: this.altKeyPressed ? "copy" : "move"
    }, r || {});
  }
  getCurrentDropEffect() {
    return this.isDraggingNativeItem() ? "copy" : this.getCurrentSourceNodeOptions().dropEffect;
  }
  getCurrentSourcePreviewNodeOptions() {
    const e = this.monitor.getSourceId(), r = this.sourcePreviewNodeOptions.get(e);
    return ut({
      anchorX: 0.5,
      anchorY: 0.5,
      captureDraggingState: !1
    }, r || {});
  }
  isDraggingNativeItem() {
    const e = this.monitor.getItemType();
    return Object.keys(ct).some(
      (r) => ct[r] === e
    );
  }
  beginDragNativeItem(e, r) {
    this.clearCurrentDragSourceNode(), this.currentNativeSource = Si(e, r), this.currentNativeHandle = this.registry.addSource(e, this.currentNativeSource), this.actions.beginDrag([
      this.currentNativeHandle
    ]);
  }
  setCurrentDragSourceNode(e) {
    this.clearCurrentDragSourceNode(), this.currentDragSourceNode = e;
    const r = 1e3;
    this.mouseMoveTimeoutTimer = setTimeout(() => {
      var n;
      return (n = this.rootElement) === null || n === void 0 ? void 0 : n.addEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
    }, r);
  }
  clearCurrentDragSourceNode() {
    if (this.currentDragSourceNode) {
      if (this.currentDragSourceNode = null, this.rootElement) {
        var e;
        (e = this.window) === null || e === void 0 || e.clearTimeout(this.mouseMoveTimeoutTimer || void 0), this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, !0);
      }
      return this.mouseMoveTimeoutTimer = null, !0;
    }
    return !1;
  }
  handleDragStart(e, r) {
    e.defaultPrevented || (this.dragStartSourceIds || (this.dragStartSourceIds = []), this.dragStartSourceIds.unshift(r));
  }
  handleDragEnter(e, r) {
    this.dragEnterTargetIds.unshift(r);
  }
  handleDragOver(e, r) {
    this.dragOverTargetIds === null && (this.dragOverTargetIds = []), this.dragOverTargetIds.unshift(r);
  }
  handleDrop(e, r) {
    this.dropTargetIds.unshift(r);
  }
  constructor(e, r, n) {
    this.sourcePreviewNodes = /* @__PURE__ */ new Map(), this.sourcePreviewNodeOptions = /* @__PURE__ */ new Map(), this.sourceNodes = /* @__PURE__ */ new Map(), this.sourceNodeOptions = /* @__PURE__ */ new Map(), this.dragStartSourceIds = null, this.dropTargetIds = [], this.dragEnterTargetIds = [], this.currentNativeSource = null, this.currentNativeHandle = null, this.currentDragSourceNode = null, this.altKeyPressed = !1, this.mouseMoveTimeoutTimer = null, this.asyncEndDragFrameId = null, this.dragOverTargetIds = null, this.lastClientOffset = null, this.hoverRafId = null, this.getSourceClientOffset = (i) => {
      const o = this.sourceNodes.get(i);
      return o && Mt(o) || null;
    }, this.endDragNativeItem = () => {
      this.isDraggingNativeItem() && (this.actions.endDrag(), this.currentNativeHandle && this.registry.removeSource(this.currentNativeHandle), this.currentNativeHandle = null, this.currentNativeSource = null);
    }, this.isNodeInDocument = (i) => !!(i && this.document && this.document.body && this.document.body.contains(i)), this.endDragIfSourceWasRemovedFromDOM = () => {
      const i = this.currentDragSourceNode;
      i == null || this.isNodeInDocument(i) || (this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover());
    }, this.scheduleHover = (i) => {
      this.hoverRafId === null && typeof requestAnimationFrame < "u" && (this.hoverRafId = requestAnimationFrame(() => {
        this.monitor.isDragging() && this.actions.hover(i || [], {
          clientOffset: this.lastClientOffset
        }), this.hoverRafId = null;
      }));
    }, this.cancelHover = () => {
      this.hoverRafId !== null && typeof cancelAnimationFrame < "u" && (cancelAnimationFrame(this.hoverRafId), this.hoverRafId = null);
    }, this.handleTopDragStartCapture = () => {
      this.clearCurrentDragSourceNode(), this.dragStartSourceIds = [];
    }, this.handleTopDragStart = (i) => {
      if (i.defaultPrevented)
        return;
      const { dragStartSourceIds: o } = this;
      this.dragStartSourceIds = null;
      const s = he(i);
      this.monitor.isDragging() && (this.actions.endDrag(), this.cancelHover()), this.actions.beginDrag(o || [], {
        publishSource: !1,
        getSourceClientOffset: this.getSourceClientOffset,
        clientOffset: s
      });
      const { dataTransfer: a } = i, c = Ne(a);
      if (this.monitor.isDragging()) {
        if (a && typeof a.setDragImage == "function") {
          const f = this.monitor.getSourceId(), p = this.sourceNodes.get(f), d = this.sourcePreviewNodes.get(f) || p;
          if (d) {
            const { anchorX: h, anchorY: v, offsetX: m, offsetY: S } = this.getCurrentSourcePreviewNodeOptions(), I = Di(p, d, s, {
              anchorX: h,
              anchorY: v
            }, {
              offsetX: m,
              offsetY: S
            });
            a.setDragImage(d, I.x, I.y);
          }
        }
        try {
          a == null || a.setData("application/json", {});
        } catch {
        }
        this.setCurrentDragSourceNode(i.target);
        const { captureDraggingState: u } = this.getCurrentSourcePreviewNodeOptions();
        u ? this.actions.publishDragSource() : setTimeout(
          () => this.actions.publishDragSource(),
          0
        );
      } else if (c)
        this.beginDragNativeItem(c);
      else {
        if (a && !a.types && (i.target && !i.target.hasAttribute || !i.target.hasAttribute("draggable")))
          return;
        i.preventDefault();
      }
    }, this.handleTopDragEndCapture = () => {
      this.clearCurrentDragSourceNode() && this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleTopDragEnterCapture = (i) => {
      if (this.dragEnterTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
      if (!this.enterLeaveCounter.enter(i.target) || this.monitor.isDragging())
        return;
      const { dataTransfer: a } = i, c = Ne(a);
      c && this.beginDragNativeItem(c, a);
    }, this.handleTopDragEnter = (i) => {
      const { dragEnterTargetIds: o } = this;
      if (this.dragEnterTargetIds = [], !this.monitor.isDragging())
        return;
      this.altKeyPressed = i.altKey, o.length > 0 && this.actions.hover(o, {
        clientOffset: he(i)
      }), o.some(
        (a) => this.monitor.canDropOnTarget(a)
      ) && (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect()));
    }, this.handleTopDragOverCapture = (i) => {
      if (this.dragOverTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      }
    }, this.handleTopDragOver = (i) => {
      const { dragOverTargetIds: o } = this;
      if (this.dragOverTargetIds = [], !this.monitor.isDragging()) {
        i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none");
        return;
      }
      this.altKeyPressed = i.altKey, this.lastClientOffset = he(i), this.scheduleHover(o), (o || []).some(
        (a) => this.monitor.canDropOnTarget(a)
      ) ? (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = this.getCurrentDropEffect())) : this.isDraggingNativeItem() ? i.preventDefault() : (i.preventDefault(), i.dataTransfer && (i.dataTransfer.dropEffect = "none"));
    }, this.handleTopDragLeaveCapture = (i) => {
      this.isDraggingNativeItem() && i.preventDefault(), this.enterLeaveCounter.leave(i.target) && (this.isDraggingNativeItem() && setTimeout(
        () => this.endDragNativeItem(),
        0
      ), this.cancelHover());
    }, this.handleTopDropCapture = (i) => {
      if (this.dropTargetIds = [], this.isDraggingNativeItem()) {
        var o;
        i.preventDefault(), (o = this.currentNativeSource) === null || o === void 0 || o.loadDataTransfer(i.dataTransfer);
      } else Ne(i.dataTransfer) && i.preventDefault();
      this.enterLeaveCounter.reset();
    }, this.handleTopDrop = (i) => {
      const { dropTargetIds: o } = this;
      this.dropTargetIds = [], this.actions.hover(o, {
        clientOffset: he(i)
      }), this.actions.drop({
        dropEffect: this.getCurrentDropEffect()
      }), this.isDraggingNativeItem() ? this.endDragNativeItem() : this.monitor.isDragging() && this.actions.endDrag(), this.cancelHover();
    }, this.handleSelectStart = (i) => {
      const o = i.target;
      typeof o.dragDrop == "function" && (o.tagName === "INPUT" || o.tagName === "SELECT" || o.tagName === "TEXTAREA" || o.isContentEditable || (i.preventDefault(), o.dragDrop()));
    }, this.options = new Ti(r, n), this.actions = e.getActions(), this.monitor = e.getMonitor(), this.registry = e.getRegistry(), this.enterLeaveCounter = new vi(this.isNodeInDocument);
  }
}
const Ei = function(e, r, n) {
  return new Oi(e, r, n);
}, Li = (t, e, r) => {
  const n = t.currentTarget.querySelectorAll(
    '[data-isCategory="true"], [role="option"]:not([data-focus-disabled="true"])'
  ).length;
  t.key === "ArrowDown" ? (t.preventDefault(), e === -1 ? r(1) : e < n - 1 && r(e + 1)) : t.key === "ArrowUp" ? (t.preventDefault(), e >= n ? r(n - 2) : e > 0 && r(e - 1)) : t.key === "Home" ? (t.preventDefault(), r(0)) : t.key === "End" && (t.preventDefault(), r(n - 1));
}, Fi = (t) => {
  let e = 0;
  return t.map((r) => {
    if (r.name && (r.displayOrderIndex = e++), !r.grouped) {
      const n = r.items.map((i) => (i.displayOrderIndex = e++, i));
      r.items = n;
    }
    return r;
  });
}, Ri = (t) => {
  const e = [], r = {};
  let n = 0;
  return t.forEach((i, o) => {
    i.listIndex = o, i.subcategory ? r[i.subcategory] === void 0 ? (e.push({
      items: [i],
      name: i.subcategory,
      grouped: i.grouped,
      index: n
    }), r[i.subcategory] = n, n += 1) : e[r[i.subcategory]].items.push(i) : (e.push({ name: "", index: n, items: [i] }), n += 1);
  }), Fi(e);
}, Ni = (t) => {
  let e = 0, r = 0;
  return t.reduce((n, i, o) => {
    if (i.listIndex = o, i.category)
      if (n[i.category] || (n[i.category] = { category: i.category, items: [], subcategories: [], index: e }, e += 1), i.subcategory) {
        const s = n[i.category].subcategories.find((a) => a.name === i.subcategory);
        s ? s.items.push(i) : (n[i.category].subcategories.push({
          items: [i],
          name: i.subcategory,
          grouped: i.grouped,
          index: r
        }), r += 1);
      } else i.value !== void 0 && n[i.category].items.push(i);
    return n;
  }, {});
}, Pi = (t, e, r) => {
  let n = 0;
  return e.reduce((i, o, s) => {
    t[o].displayOrderIndex = n++;
    const a = t[o].subcategories.map((u) => {
      if (r[s] && (u.displayOrderIndex = n++), !u.grouped) {
        const f = u.items.map((p) => (r[s] && (p.displayOrderIndex = n++), p));
        u.items = f;
      }
      return u;
    }), c = t[o].items.map((u) => (r[s] && (u.displayOrderIndex = n++), u));
    return i[o] = {
      ...t[o],
      items: c,
      subcategories: a
    }, i;
  }, {});
}, ji = A()(({ constructs: t, mode: e, palette: r, spacing: n, typography: i }, { disabled: o }, s) => {
  var a, c, u;
  return {
    root: {
      backgroundColor: g.ifFeature("encore", t.surface.neutral.xxWeak, r.gray[200]),
      boxSizing: "border-box",
      "&:hover, &:focus": {
        [`& .${s.container}`]: {
          backgroundColor: g.ifFeature("encore", t.surface.neutral.weak, r.gray[300]),
          [`& .${s.leftContent}`]: {
            fill: r.primary.main
          },
          [`& .${s.title}`]: {
            color: r.primary.main
          }
        }
      },
      outline: e === F.Dye ? `1px solid ${R.main}` : void 0
    },
    container: {
      borderBottom: g.ifFeature("encore", `1px solid ${t.border.neutral.xWeak}`, `1px solid ${r.gray[400]}`),
      display: "flex",
      // @startCleanup encore
      height: g.ifFeature("encore", void 0, 40),
      // @endCleanup encore
      padding: g.ifFeature("encore", n(1.5, 2.5), "0 10px")
    },
    selected: {
      backgroundColor: g.ifFeature("encore", t.surface.primary.strong, r.primary.main),
      [`& .${s.leftContent}, & .${s.rightContent}`]: {
        color: r.common.white
      },
      "&:hover, &:focus": {
        backgroundColor: g.ifFeature("encore", t.surface.primary.strong, r.primary.main)
      }
    },
    centerHorizontal: {
      alignItems: "center",
      display: "flex",
      flexDirection: "row"
    },
    leftContent: {
      color: g.ifFeature(
        "encore",
        o ? t.text.neutral.medium : t.text.neutral.xStrong,
        o ? r.gray[600] : r.gray[1e3]
      ),
      fill: g.ifFeature("encore", t.text.primary.strong),
      flex: 2
    },
    title: {
      color: g.ifFeature("encore", t.text.neutral.xStrong, r.gray[1e3]),
      fontSize: g.ifFeature("encore", i.large.fontSize, (a = i.large) == null ? void 0 : a.fontSize),
      fontWeight: g.ifFeature("encore", i.fontWeightSemibold, i.fontWeightBold),
      lineHeight: g.ifFeature("encore", i.large.lineHeight, (c = i.large) == null ? void 0 : c.lineHeight),
      marginLeft: g.ifFeature("encore", n(1.5), "7px"),
      maxWidth: g.ifFeature("encore", 190, 210),
      overflow: "hidden",
      textOverflow: "ellipsis",
      userSelect: "none",
      whiteSpace: "nowrap"
    },
    rightContent: {
      color: r.gray[600],
      fontSize: g.ifFeature("encore", i.medium.fontSize, (u = i.small) == null ? void 0 : u.fontSize),
      lineHeight: g.ifFeature("encore", i.medium.lineHeight, i.small.lineHeight),
      userSelect: "none"
    },
    expandedDropdown: {
      fill: r.primary.main
    },
    items: {
      outline: e === F.Dye ? `1px solid ${R.main}` : void 0
    }
  };
});
function dt(t, e) {
  return `inset 0 4px 0 0 ${t}1a, inset 0 -4px 0 0 ${t}1a, 0 -1px 0 0 ${e || t}`;
}
const ki = A()(
  ({ constructs: t, mode: e, palette: r }, { disabled: n, rightSide: i }, o) => ({
    hoverRoot: {
      outline: e === F.Dye ? `1px solid ${R.main}` : void 0,
      [`&:hover .${o.icon}, &:focus-within .${o.icon}`]: {
        display: n ? "" : "initial"
      },
      "&&": g.ifFeature("encore", {
        "&:not(:last-child)": {
          "& div": {
            "& div": {
              borderBottomColor: t.border.neutral.xWeak
            },
            "&:focus": !n && {
              "& div": {
                borderBottomColor: t.border.primary.medium
              }
            },
            "&:hover": !n && !i && {
              "& div": {
                borderBottomColor: t.border.primary.strong
              }
            }
          }
        }
      })
    },
    icon: {
      display: "none",
      fill: i ? r.gray[500] : r.primary.main,
      height: g.ifFeature("encore", 20)
    }
  })
), _i = A()(
  ({ constructs: t, mode: e, palette: r, spacing: n, typography: i }, { disabled: o, rightSide: s, variant: a }, c) => {
    var u, f;
    return {
      root: g.ifFeature(
        "encore",
        {
          backgroundColor: r.common.white,
          color: t.text.neutral.xStrong,
          cursor: o ? void 0 : "pointer",
          outline: e === F.Dye ? `1px solid ${R.main}` : void 0,
          "&:focus": {
            [`& .${c.container}`]: {
              borderBottomColor: t.border.primary.medium,
              boxShadow: dt(t.border.primary.medium)
            },
            [`& .${c.containerTextHover} .${c.leftContent}`]: {
              color: o ? void 0 : r.primary.main
            },
            [`& .${c.rightContent}`]: {
              color: o ? void 0 : t.text.neutral.xWeak
            }
          },
          "&:hover": !o && {
            [`& .${c.container}`]: {
              backgroundColor: s ? void 0 : t.surface.primary.weak,
              borderBottomColor: t.border.primary.strong,
              boxShadow: s ? void 0 : `0 -1px 0 0 ${t.border.primary.strong}`
            },
            [`& .${c.containerTextHover} .${c.leftContent}`]: {
              color: s ? void 0 : r.primary.main
            },
            [`& .${c.rightContent}`]: {
              color: t.text.neutral.weak
            }
          },
          // The last item should not have a bottom border since it overlaps the container bottom border.
          // However, when using `TransferListHoverItem`, this is actually a child of the last item.
          // Thus, we get the last item relative to the container/listbox.
          [`[role="listbox"] > &:last-child .${c.container}, [role="listbox"] > :last-child & .${c.container}`]: {
            borderBottom: "none"
          }
        },
        {
          backgroundColor: r.common.white,
          outline: e === F.Dye ? `1px solid ${R.main}` : void 0,
          "&:focus": {
            [`& .${c.container}`]: {
              backgroundColor: o ? r.grey[200] : `${r.primary.lightest}1A`
            }
          },
          "&:hover": {
            [`& .${c.container}`]: {
              backgroundColor: o ? void 0 : `${r.primary.lightest}1A`
            }
          },
          "&:hover, &:focus": {
            [`& .${c.containerTextHover} .${c.leftContent}`]: {
              color: o ? void 0 : r.primary.main
            }
          }
        }
      ),
      containerTextHover: {},
      container: g.ifFeature(
        "encore",
        {
          borderBottom: `1px solid ${t.border.neutral.xWeak}`,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: a === "stacked" ? "column" : void 0,
          padding: n(1.5, 2.5)
        },
        {
          borderBottom: `1px solid ${r.gray[400]}`,
          boxSizing: "border-box",
          display: "flex",
          height: 40,
          padding: "0 10px"
        }
      ),
      disabled: {
        backgroundColor: r.gray[100],
        color: r.gray[700]
      },
      selected: g.ifFeature(
        "encore",
        {
          "&&": {
            backgroundColor: t.surface.primary.strong,
            [`& .${c.container}`]: {
              borderBottomColor: t.surface.neutral.inverted,
              boxShadow: `0 -1px 0 0 ${t.surface.neutral.inverted}`
            },
            "&:hover, &:focus": {
              [`& ${c.container}`]: {
                borderBottomColor: t.surface.neutral.inverted
              }
            },
            "&:focus": {
              [`& .${c.container}`]: {
                borderBottomColor: t.surface.neutral.inverted,
                boxShadow: dt(t.border.primary.medium, t.surface.neutral.inverted)
              }
            },
            "&:hover": !o && {
              [`& .${c.container}`]: {
                backgroundColor: s ? void 0 : t.surface.primary.xStrong
              }
            },
            "&&": {
              [`& .${c.leftContent}, & .${c.rightContent}`]: {
                color: t.text.neutral.inverted,
                fill: t.icon.neutral.inverted
              }
            },
            "&:last-child": {
              borderBottom: "none"
            }
          }
        },
        {
          "&&": {
            // The selected css is being overwritten by the root css in a few cases. This allows the selected css to appear at all times while selected.
            backgroundColor: r.primary.main
          },
          [`& .${c.leftContent}, & .${c.rightContent}`]: {
            color: r.common.white,
            fill: r.common.white
          },
          "&:hover, &:focus": {
            backgroundColor: r.primary.main
          }
        }
      ),
      centerHorizontal: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
      },
      leftContent: {
        flex: 2
      },
      title: {
        lineHeight: (u = i.medium) == null ? void 0 : u.lineHeight,
        maxWidth: g.ifFeature("encore", 190, 210),
        overflow: "hidden",
        textOverflow: "ellipsis",
        userSelect: "none",
        whiteSpace: "nowrap"
      },
      rightContent: {
        color: g.ifFeature("encore", t.text.neutral.xWeak, r.gray[700]),
        fontSize: g.ifFeature("encore", i.medium.fontSize, (f = i.small) == null ? void 0 : f.fontSize),
        lineHeight: g.ifFeature("encore", i.medium.lineHeight, "19px"),
        userSelect: "none"
      }
    };
  }
);
function Ke(t) {
  const {
    children: e,
    disabled: r,
    isFocused: n,
    listIndex: i,
    onClick: o,
    onFocus: s,
    onHover: a,
    toolTipRender: c,
    rowKey: u,
    selected: f = !1,
    tabIndex: p,
    title: d,
    value: h
  } = t, { classes: v } = _i(t), [m, S] = N();
  U(() => {
    m && n && m.focus();
  }, [m, n]);
  const y = ce(
    (O) => {
      o && typeof o == "function" && !r && o({ value: h, rowKey: u, listIndex: i }, O.nativeEvent);
    },
    [r, i, o, u, h]
  ), b = ce(
    (O) => {
      O.key === " " && (O.preventDefault(), y({ nativeEvent: O }));
    },
    [y]
  ), I = me(v.root, {
    [v.selected]: f
  }), T = me(
    v.container,
    {
      [v.disabled]: r
    },
    {
      [v.containerTextHover]: !f
    }
  );
  function C(O) {
    a && typeof a == "function" && a(O);
  }
  function D(O) {
    s && typeof s == "function" && s(O);
  }
  return /* @__PURE__ */ l.jsx(
    "div",
    {
      "aria-disabled": r,
      "aria-selected": f,
      className: I,
      "data-focus-disabled": i < 0,
      onBlur: () => {
        D(!1);
      },
      onClick: y,
      onFocus: () => {
        D(!0);
      },
      onKeyDown: b,
      onMouseLeave: () => {
        C(!1);
      },
      onMouseOver: () => {
        C(!0);
      },
      ref: S,
      role: "option",
      tabIndex: p,
      children: /* @__PURE__ */ l.jsxs("div", { className: T, children: [
        typeof c == "function" && c(m, { disabled: r, title: d, value: h }),
        /* @__PURE__ */ l.jsx("div", { className: `${v.leftContent} ${v.centerHorizontal}`, children: /* @__PURE__ */ l.jsx("div", { className: v.title, children: d }) }),
        e && /* @__PURE__ */ l.jsx("div", { className: `${v.rightContent} ${v.centerHorizontal}`, children: e })
      ] })
    }
  );
}
const ue = (t) => {
  const { classes: e } = ki(t), r = le(null), { listIndex: n, icon: i, reorderSubcategories: o, title: s, rightSide: a, onHover: c } = t, [, u] = Pt({
    accept: "Subcategory",
    hover(d, h) {
      var D;
      if (!r.current) return;
      const v = d.name, m = d.index, S = n, y = s;
      if (v === y) return;
      const b = h.getClientOffset(), I = (D = r.current) == null ? void 0 : D.getBoundingClientRect(), T = (I.bottom - I.top) / 2, C = b !== null ? b.y - I.top : 0;
      S && m < S && C < T || S && m > S && C > T || o && typeof o == "function" && o(v, y);
    }
  }), [{ isDragging: f }, p] = Nt(() => ({
    type: "Subcategory",
    item: { name: s, index: n },
    collect: (d) => ({
      isDragging: d.isDragging()
    })
  }));
  return p(u(r)), /* @__PURE__ */ l.jsx("div", { className: e.hoverRoot, ref: a ? r : void 0, style: f ? { opacity: 0 } : void 0, children: /* @__PURE__ */ l.jsx(
    Ke,
    {
      ...t,
      onHover: (d) => {
        c && typeof c == "function" && c(d);
      },
      selected: !1,
      children: /* @__PURE__ */ l.jsx("div", { className: e.icon, children: i })
    }
  ) });
}, Ai = A()(
  ({ constructs: t, mode: e, palette: r, spacing: n, typography: i }, { disabled: o, transferListSide: s }, a) => {
    var c, u;
    return {
      root: {
        backgroundColor: r.common.white,
        border: g.ifFeature("encore", "1px solid transparent"),
        // @startCleanup encore
        borderBottom: g.ifFeature("encore", void 0, `1px solid ${r.gray[400]}`),
        // @endCleanup encore
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        outline: e === F.Dye ? `1px solid ${R.main}` : void 0,
        paddingBottom: g.ifFeature("encore", n(4.5), "15px"),
        position: "relative",
        "&:not(:last-child)": {
          borderBottomColor: g.ifFeature("encore", t.border.neutral.xWeak)
        }
      },
      draggingStyles: {
        opacity: 0
      },
      rootHover: g.ifFeature(
        "encore",
        {
          "&&": {
            backgroundColor: s === L.RIGHT ? void 0 : t.surface.primary.weak,
            borderColor: s === L.RIGHT ? void 0 : t.border.primary.strong,
            [`& .${a.title}`]: {
              color: s === L.RIGHT ? void 0 : t.text.primary.strong
            }
          }
        },
        {
          backgroundColor: `${r.primary.lightest}1A`
        }
      ),
      subcategoryOption: {
        height: "100%",
        position: "absolute",
        width: "100%"
      },
      container: {
        display: "flex",
        // @startCleanup encore
        height: g.ifFeature("encore", void 0, 40),
        // @endCleanup encore
        padding: g.ifFeature("encore", n(1.5, 3, 1.5, 2.5), "0 10px")
      },
      centerHorizontal: {
        // @startCleanup encore
        alignItems: g.ifFeature("encore", void 0, "center"),
        // @endCleanup encore
        display: "flex",
        flexDirection: "row"
      },
      leftContent: {
        color: g.ifFeature("encore", t.text.neutral.medium, o ? r.gray[600] : r.gray[1e3]),
        flex: 2
      },
      title: {
        fontWeight: g.ifFeature("encore", i.fontWeightSemibold),
        lineHeight: (c = i.medium) == null ? void 0 : c.lineHeight,
        maxWidth: 210,
        overflow: "hidden",
        marginLeft: g.ifFeature("encore", n(3.5)),
        textOverflow: "ellipsis",
        userSelect: "none",
        whiteSpace: "nowrap"
      },
      rightContent: {
        color: r.gray[600],
        fontSize: g.ifFeature("encore", i.medium.fontSize, (u = i.small) == null ? void 0 : u.fontSize),
        lineHeight: g.ifFeature("encore", i.medium.lineHeight, "19px"),
        userSelect: "none"
      },
      icon: {
        display: "none",
        fill: s === L.RIGHT ? r.gray[600] : r.primary.main
      },
      hover: {
        display: "initial"
      },
      childrenContainer: {
        border: g.ifFeature("encore", `1px solid ${t.border.neutral.xWeak}`),
        // @startCleanup encore
        borderLeft: g.ifFeature("encore", void 0, `1px solid ${r.gray[400]}`),
        borderRight: g.ifFeature("encore", void 0, `1px solid ${r.gray[400]}`),
        borderTop: g.ifFeature("encore", void 0, `1px solid ${r.gray[400]}`),
        // @endCleanup encore
        display: "flex",
        justifyContent: "center",
        margin: g.ifFeature("encore", "46px 28px 0", "40px 15px 0"),
        zIndex: 1
      },
      children: {
        width: "100%"
      }
    };
  }
), qe = (t) => {
  const {
    focusedIndex: e,
    grouped: r = !1,
    onClick: n,
    onFocus: i,
    icon: o,
    index: s,
    isFocused: a,
    items: c,
    disabled: u,
    name: f,
    reorderSubcategories: p,
    subcategoryClasses: d,
    tabIndex: h,
    transferListSide: v,
    transferListItemProps: m
  } = t, [S, y] = N(!1), [b, I] = N(!1), T = le(null), { classes: C, cx: D } = Ai(t, { props: { classes: d } }), [, O] = Pt({
    accept: "Subcategory",
    hover(w, ne) {
      var fe;
      if (!T.current || v !== L.RIGHT) return;
      const X = w.name, Q = w.index, Z = s, ie = f;
      if (X === ie) return;
      const P = ne.getClientOffset(), G = (fe = T.current) == null ? void 0 : fe.getBoundingClientRect(), J = (G.bottom - G.top) / 2, de = P !== null ? P.y - G.top : 0;
      Q < Z && de < J || Q > Z && de > J || p && typeof p == "function" && p(X, ie);
    }
  }), [{ isDragging: M }, V] = Nt(() => ({
    type: "Subcategory",
    item: { name: f, index: s },
    collect: (w) => ({
      isDragging: w.isDragging()
    })
  }));
  V(O(T)), U(() => {
    T != null && T.current && a && T.current.focus();
  }, [T, a]);
  const W = me(C.root, {
    [C.rootHover]: S,
    [C.draggingStyles]: M
  }), H = ce(
    (w) => {
      n && typeof n == "function" && !u && n({ value: { key: "subcategory" }, rowKey: f, listIndex: s }, w.nativeEvent, !0);
    },
    [u, s, n, f]
  ), Te = ce(
    (w) => {
      w.key === " " && (w.preventDefault(), H({ nativeEvent: w }));
    },
    [H]
  );
  function Y(w) {
    i && typeof i == "function" && i(w);
  }
  const we = () => c.map((w) => {
    const { title: ne, children: X, value: Q } = w;
    return /* @__PURE__ */ Se(
      ue,
      {
        ...m,
        disabled: r ? !0 : w.disabled,
        icon: o,
        isFocused: e === w.displayOrderIndex,
        key: w.rowKey,
        listIndex: w.displayOrderIndex || -2,
        onClick: n,
        rightSide: v === L.RIGHT,
        rowKey: w.rowKey,
        tabIndex: K(e, w.displayOrderIndex),
        title: ne,
        value: Q
      },
      X
    );
  });
  return /* @__PURE__ */ l.jsxs(
    "div",
    {
      "aria-label": f,
      className: W,
      onBlur: () => {
        Y(!1), y(!1);
      },
      onFocus: () => {
        Y(!0), b || y(!0);
      },
      onMouseOut: () => {
        y(!1);
      },
      onMouseOver: () => {
        b || y(!0);
      },
      role: "group",
      children: [
        /* @__PURE__ */ l.jsx(
          "div",
          {
            "aria-selected": !1,
            className: C.subcategoryOption,
            onBlur: () => {
              Y(!1), y(!1);
            },
            onClick: (w) => {
              b || H(w);
            },
            onFocus: () => {
              Y(!0), b || y(!0);
            },
            onKeyDown: Te,
            ref: T,
            role: "option",
            tabIndex: h,
            children: /* @__PURE__ */ l.jsxs("div", { className: C.container, children: [
              /* @__PURE__ */ l.jsx("div", { className: D(C.leftContent, C.centerHorizontal), children: /* @__PURE__ */ l.jsx("div", { className: C.title, children: f }) }),
              /* @__PURE__ */ l.jsx("div", { className: D(C.rightContent, C.centerHorizontal), children: /* @__PURE__ */ l.jsx("div", { className: D(C.icon, { [C.hover]: S }), children: o }) })
            ] })
          }
        ),
        /* @__PURE__ */ l.jsx(
          "div",
          {
            className: C.childrenContainer,
            onBlur: (w) => {
              w.stopPropagation();
            },
            onFocus: (w) => {
              w.stopPropagation();
            },
            onKeyPress: () => null,
            onMouseEnter: () => {
              r || (I(!0), y(!1));
            },
            onMouseLeave: () => {
              r || (I(!1), y(!0));
            },
            role: "group",
            children: /* @__PURE__ */ l.jsx("div", { className: C.children, children: we() })
          }
        )
      ]
    }
  );
};
function Bt(t) {
  const {
    displayOrderIndex: e,
    expanded: r,
    focusedIndex: n,
    items: i,
    name: o,
    onClick: s,
    onToggleExpand: a,
    subcategories: c,
    transferListItemProps: u,
    transferListSide: f
  } = t, p = le(null), { classes: d } = ji(u);
  U(() => {
    p != null && p.current && e === n && p.current.focus();
  }, [p, e, n]);
  const h = (I) => {
    (I.key === " " || I.key === "Enter") && (I.preventDefault(), a(!r));
  }, v = () => i.map((I) => {
    const { children: T, displayOrderIndex: C, title: D, value: O } = I;
    return /* @__PURE__ */ Se(
      ue,
      {
        ...u,
        disabled: I.disabled,
        icon: g.ifFeature("encore", /* @__PURE__ */ l.jsx(B, { name: "arrow-right-solid", size: 20 }), /* @__PURE__ */ l.jsx(ve, {})),
        isFocused: n === C,
        key: I.rowKey,
        listIndex: C || -2,
        onClick: s,
        rightSide: !1,
        rowKey: I.rowKey,
        tabIndex: K(n, C),
        title: D,
        value: O
      },
      T
    );
  }), m = () => {
    if (c)
      return c.map((I) => {
        const { name: T, grouped: C = !1, items: D, index: O, displayOrderIndex: M } = I;
        return /* @__PURE__ */ l.jsx(
          qe,
          {
            focusedIndex: n,
            grouped: C,
            icon: g.ifFeature("encore", /* @__PURE__ */ l.jsx(B, { name: "arrow-right-solid", size: 20 }), /* @__PURE__ */ l.jsx(ve, {})),
            index: O,
            isFocused: n === M,
            items: D,
            name: T,
            onClick: s,
            subcategoryClasses: t.subcategoryClasses,
            tabIndex: K(n, M),
            transferListItemProps: u,
            transferListSide: f
          },
          T
        );
      });
  }, S = o.replace(" ", "-"), y = `transfer-list-category-${S}`, b = `transfer-list-category-${S}-contents`;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    /* @__PURE__ */ l.jsx(
      "div",
      {
        "aria-controls": b,
        "aria-expanded": r,
        className: d.root,
        "data-isCategory": !0,
        id: y,
        onClick: () => a(!r),
        onKeyDown: h,
        ref: p,
        role: "button",
        tabIndex: K(n, e),
        children: /* @__PURE__ */ l.jsx("div", { className: d.container, children: /* @__PURE__ */ l.jsxs("div", { className: `${d.leftContent} ${d.centerHorizontal}`, children: [
          r ? g.ifFeature(
            "encore",
            /* @__PURE__ */ l.jsx(B, { name: "angle-down-regular", size: 16 }),
            /* @__PURE__ */ l.jsx(rr, { className: d.expandedDropdown })
          ) : g.ifFeature("encore", /* @__PURE__ */ l.jsx(B, { name: "angle-right-regular", size: 16 }), /* @__PURE__ */ l.jsx(ft, {})),
          /* @__PURE__ */ l.jsx("div", { className: d.title, children: o })
        ] }) })
      }
    ),
    /* @__PURE__ */ l.jsxs("div", { "aria-labelledby": y, className: d.items, id: b, role: "listbox", children: [
      r && m(),
      r && v()
    ] })
  ] });
}
function zt(t) {
  const { listItems: e } = t, [r, n] = N([]), [i, o] = N([]);
  let s = Ni(e);
  const a = Object.keys(s);
  r.length === 0 && a.length !== 0 ? (n(a), o(a.map(() => !1))) : s = r.reduce((f, p, d) => (s[p] !== void 0 ? (f[p] = s[p], f[p].index = d) : f[p] = { category: p, subcategories: [], items: [], index: d }, f), {}), s = Pi(s, r, i);
  const c = (u, f) => {
    o((p) => {
      const d = [...p];
      return d[u] = f, d;
    });
  };
  return /* @__PURE__ */ l.jsx(l.Fragment, { children: Object.values(s).map((u) => /* @__PURE__ */ Se(
    Bt,
    {
      ...t,
      displayOrderIndex: u.displayOrderIndex,
      expanded: i[u.index],
      index: u.index,
      items: u.items,
      key: u.category,
      name: u.category,
      onToggleExpand: (f) => c(u.index, f),
      subcategories: u.subcategories,
      transferListItemProps: t
    }
  )) });
}
function Hi(t, e, r, n, i, o, s) {
  if (Array.isArray(t))
    return o === L.LEFT ? [
      /* @__PURE__ */ l.jsx(
        zt,
        {
          focusedIndex: n,
          listItems: t,
          onClick: e,
          reorderSubcategories: s,
          transferListItemProps: r,
          transferListSide: o
        },
        0
      )
    ] : Ri(t).map((a) => {
      if (a.name !== "") {
        const { name: h, grouped: v = !1, items: m, index: S, displayOrderIndex: y } = a;
        return /* @__PURE__ */ l.jsx(
          qe,
          {
            focusedIndex: n,
            grouped: v,
            icon: g.ifFeature("encore", /* @__PURE__ */ l.jsx(B, { name: "circle-xmark-solid", size: 20 }), /* @__PURE__ */ l.jsx(Pe, {})),
            index: S,
            isFocused: n === y,
            items: m,
            name: h,
            onClick: e,
            reorderSubcategories: s,
            tabIndex: K(n, y),
            transferListItemProps: r,
            transferListSide: o
          },
          h
        );
      }
      const c = a.items[0], { title: u, children: f, value: p, displayOrderIndex: d } = c;
      return /* @__PURE__ */ Se(
        ue,
        {
          ...r,
          disabled: c.disabled,
          icon: g.ifFeature("encore", /* @__PURE__ */ l.jsx(B, { name: "circle-xmark-solid", size: 20 }), /* @__PURE__ */ l.jsx(Pe, {})),
          isFocused: n === d,
          key: c.rowKey,
          listIndex: a.index,
          onClick: e,
          reorderSubcategories: s,
          rightSide: o === L.RIGHT,
          rowKey: c.rowKey,
          tabIndex: K(n, d),
          title: u,
          value: p
        },
        f
      );
    });
}
function $i(t, e, r, n, i, o, s, a) {
  const c = {
    ...r,
    ...t,
    onClick: e,
    isFocused: n,
    tabIndex: i,
    listIndex: o,
    icon: g.ifFeature(
      "encore",
      a === L.RIGHT ? /* @__PURE__ */ l.jsx(B, { name: "circle-xmark-solid", size: 20 }) : /* @__PURE__ */ l.jsx(B, { name: "arrow-right-solid", size: 20 }),
      a === L.RIGHT ? /* @__PURE__ */ l.jsx(Pe, {}) : /* @__PURE__ */ l.jsx(ve, {})
    ),
    rightSide: s === z.SINGLE_SELECT && a === L.RIGHT
  }, f = {
    [z.SINGLE_SELECT]: ue,
    [z.MULTI_SELECT]: Ke
  }[s];
  return /* @__PURE__ */ l.jsx(f, { ...c }, t.rowKey);
}
function Mi(t, e, r, n, i, o) {
  if (Array.isArray(t))
    return t.map((s, a) => {
      const c = a === n, u = K(n, a, t.length);
      return $i(s, e, r, c, u, a, i, o);
    });
}
const Bi = A()(({ borderRadiuses: t, constructs: e, mode: r, palette: n, typography: i }) => {
  var o;
  return {
    rootDimensions: {
      height: g.ifFeature("encore", 368, 374),
      width: g.ifFeature("encore", 320, 316)
    },
    rootDisplay: {
      display: "flex",
      flexDirection: "column"
    },
    root: {
      backgroundColor: g.ifFeature("encore", e.surface.neutral.xWeak, n.gray[100]),
      border: `1px solid ${g.ifFeature("encore", e.border.neutral.weak, n.gray[400])}`,
      borderRadius: g.ifFeature("encore", t[400], 3),
      boxSizing: "border-box",
      outline: r === F.Dye ? `1px solid ${R.main}` : void 0,
      overflow: g.ifFeature("encore", "clip")
    },
    itemList: {
      overflow: "hidden",
      overflowY: "auto"
    },
    title: {
      color: r === F.Dye ? R.main : g.ifFeature("encore", e.text.neutral.xStrong),
      fontSize: g.ifFeature("encore", i.small.fontSize),
      fontWeight: g.ifFeature("encore", i.fontWeightMedium, i.fontWeightBold),
      lineHeight: g.ifFeature("encore", i.small.lineHeight, (o = i.medium) == null ? void 0 : o.lineHeight),
      marginBottom: 6
    }
  };
});
function $e(t) {
  const {
    ariaLabel: e,
    categorized: r,
    listItems: n = [],
    aboveListChildren: i,
    classes: o = {},
    listHeaderChildren: s,
    listRenderer: a = r ? Hi : Mi,
    onRowSelect: c,
    title: u,
    blankState: f,
    reorderSubcategories: p,
    TransferListItemProps: d = {},
    transferListSide: h = L.LEFT,
    transferListType: v = z.MULTI_SELECT
  } = t, { classes: m } = Bi(void 0, { props: { classes: o } }), [S, y] = N(-1);
  function b(D, O, M = !1) {
    let V = [];
    if (typeof (d == null ? void 0 : d.onClick) == "function")
      try {
        d.onClick(D, O);
      } catch (W) {
        console.error("Error occurred in transfer list item click handler"), console.error(W);
      }
    if (typeof c == "function")
      try {
        V = c({ value: n, key: D.rowKey }, O, M);
      } catch (W) {
        console.error(W);
      }
    return (v === z.SINGLE_SELECT || r) && y(D.listIndex - 1), V;
  }
  function I(D) {
    return !Array.isArray(D) || D.length === 0;
  }
  const T = me(m.rootDimensions, m.root, m.rootDisplay), C = () => r && h === L.LEFT ? !0 : n.length > 0;
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    typeof i == "function" && /* @__PURE__ */ l.jsx("div", { children: i() }),
    u && /* @__PURE__ */ l.jsx("div", { className: m.title, children: u }),
    /* @__PURE__ */ l.jsxs("div", { className: T, children: [
      typeof s == "function" && g.ifFeature(
        "encore",
        /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          /* @__PURE__ */ l.jsx(tr, { flexDirection: "column", gap: 1, padding: 2, children: s() }),
          /* @__PURE__ */ l.jsx(ir, { color: "neutral-extra-weak" })
        ] }),
        /* @__PURE__ */ l.jsx("div", { children: s() })
      ),
      Array.isArray(n) && C() && typeof a == "function" && /* @__PURE__ */ l.jsx(Hn, { backend: Ei, children: /* @__PURE__ */ l.jsx(
        "div",
        {
          "aria-label": e,
          "aria-multiselectable": v === z.MULTI_SELECT && !r || void 0,
          className: m.itemList,
          onKeyDown: (D) => Li(D, S, y),
          role: r && h === L.LEFT ? "group" : "listbox",
          children: a(
            n,
            b,
            d,
            S,
            v,
            h,
            p
          )
        }
      ) }),
      I(n) && typeof f == "function" && f()
    ] })
  ] });
}
function zi(t) {
  const {
    aboveListChildren: e,
    categorized: r = !1,
    classes: n = {},
    LeftTransferListBaseProps: i = {},
    renderButtonControls: o,
    RightTransferListBaseProps: s = {},
    rightListItems: a = [],
    onLeftRowSelect: c,
    onRightRowSelect: u,
    reorderSubcategories: f,
    transferListType: p = z.MULTI_SELECT,
    variant: d,
    ...h
  } = t, { classes: v } = g.ifFeature("encore", Ze(), Ze(void 0, { props: { classes: n } })), m = br(t, r), S = [h["data-fabric-component"], "TransferList"].filter(Boolean).join(" ");
  return /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
    typeof e == "function" && /* @__PURE__ */ l.jsx("div", { children: e() }),
    /* @__PURE__ */ l.jsxs("div", { className: v.transferListRoot, "data-fabric-component": S, children: [
      /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
        $e,
        {
          ...i,
          ariaLabel: i.title || (window.jQuery ? $.__("Browse items") : "Browse items"),
          categorized: r,
          listItems: m,
          onRowSelect: c,
          TransferListItemProps: {
            variant: d,
            ...i.TransferListItemProps
          },
          transferListSide: L.LEFT,
          transferListType: p
        }
      ) }),
      g.ifFeature(
        "encore",
        p !== z.SINGLE_SELECT && typeof o == "function" && o(),
        /* @__PURE__ */ l.jsx("div", { className: v.transferListCenterColumn, children: p !== z.SINGLE_SELECT && typeof o == "function" && o() })
      ),
      /* @__PURE__ */ l.jsx("div", { children: /* @__PURE__ */ l.jsx(
        $e,
        {
          ...s,
          ariaLabel: s.title || (window.jQuery ? $.__("Selected items") : "Selected items"),
          categorized: r,
          listItems: a,
          onRowSelect: u,
          reorderSubcategories: f,
          TransferListItemProps: {
            variant: d,
            ...s.TransferListItemProps
          },
          transferListSide: L.RIGHT,
          transferListType: p
        }
      ) })
    ] })
  ] });
}
const Wi = A()(({ mode: t, palette: e, typography: r }) => ({
  root: {
    boxSizing: "border-box",
    outline: t === F.Dye ? `1px solid ${R.main}` : void 0,
    position: "relative"
  },
  searchInput: {
    backgroundColor: "white",
    border: "0",
    borderBottom: `1px solid ${e.gray[300]}`,
    boxShadow: "0 1px 2px -1px rgba(0, 0, 0, 0.1)",
    boxSizing: "border-box",
    fontSize: r.fabricFontSize("small"),
    height: "42px",
    paddingLeft: 10,
    paddingTop: 1,
    width: "100%",
    "&:focus": {
      outline: `2px solid ${e.primary.main}`
    }
  },
  searchInputWithIcon: {
    paddingLeft: "33px"
  },
  searchInputIconContainer: {
    left: 10,
    position: "absolute",
    top: 12
  },
  searchInputIcon: {
    "& > svg": {
      fill: e.gray[500]
    }
  },
  searchInputIconFocused: {
    "& > svg": {
      fill: e.primary.main
    }
  }
}));
function Wt(t) {
  const {
    biId: e,
    classes: r,
    icon: n,
    onChange: i = () => 1,
    placeholder: o
  } = t, { classes: s, cx: a } = Wi(void 0, { props: { classes: r } }), [c, u] = N(!1), f = a(s.searchInput, {
    [s.searchInputWithIcon]: !!n
  }), p = a({
    [s.searchInputIcon]: !c,
    [s.searchInputIconFocused]: c
  });
  return g.ifFeature(
    "encore",
    /* @__PURE__ */ l.jsx(
      Jt,
      {
        "aria-label": o,
        "data-bi-id": e,
        InputProps: {
          startAdornment: /* @__PURE__ */ l.jsx(er, { position: "start", children: /* @__PURE__ */ l.jsx(B, { color: "neutral-strong", name: "magnifying-glass-regular", size: 12 }) })
        },
        onBlur: () => {
          u(!1);
        },
        onChange: (d) => {
          i(d.target.value);
        },
        onFocus: () => {
          u(!0);
        },
        placeholder: o,
        size: "small"
      }
    ),
    /* @__PURE__ */ l.jsxs("div", { className: s.root, children: [
      /* @__PURE__ */ l.jsx(
        "input",
        {
          "aria-label": o,
          className: f,
          "data-bi-id": e,
          defaultValue: "",
          onBlur: () => {
            u(!1);
          },
          onChange: (d) => {
            i(d.target.value);
          },
          onFocus: () => {
            u(!0);
          },
          placeholder: o,
          type: "text"
        }
      ),
      n && /* @__PURE__ */ l.jsx("div", { className: s.searchInputIconContainer, children: /* @__PURE__ */ l.jsx("div", { className: p, children: n }) })
    ] })
  );
}
function po(t) {
  const {
    biId: e,
    LeftListProps: r = {},
    RightListProps: n = {},
    SearchProps: i,
    TransferListProps: o = {},
    handleFilterItems: s,
    FilterProps: a,
    onChange: c,
    sortList: u = (P) => P,
    emptyFilterText: f,
    variant: p
  } = t, { classes: d } = Sr(), { listItems: h = [], ...v } = r, { listItems: m = [], ...S } = n, y = { transferListCenterColumn: d.transferListCenterColumn, ...o == null ? void 0 : o.classes }, [b, I] = N([...h]), [T, C] = N([...m]), [D, O] = N(""), [M, V] = N([]), {
    availableOptions: W,
    selectedOptions: H,
    onClickAddAll: Te,
    onClickAddHighlighted: Y,
    onClickRemoveHighlighted: we,
    onClickRemoveAll: w,
    useOnAvailableSelect: ne,
    useOnSelectedSelect: X
  } = pr({
    availableOptions: b,
    selectedOptions: T,
    sortList: u,
    setAvailableOptions: I,
    setSelectedOptions: C
  });
  function Q() {
    return /* @__PURE__ */ l.jsx(
      vt,
      {
        biId: e,
        onClickAddAll: Te,
        onClickAddHighlighted: Y,
        onClickRemoveAll: w,
        onClickRemoveHighlighted: we
      }
    );
  }
  const Z = (P, G) => {
    let J;
    if (typeof s == "function")
      J = s(P, G);
    else {
      const de = fr(h, W), fe = hr(H, de), Ut = gr(P, fe);
      J = lr(G, Ut);
    }
    I(J), V(P), O(G);
  }, ie = le(H);
  return U(() => {
    typeof c == "function" && (Z(M, D), te.isEqual(H, ie.current) || (ie.current = H, c({ selected: H })));
  }, [H, c]), U(() => {
    n.listItems && C(n.listItems);
  }, [n.listItems]), /* @__PURE__ */ l.jsx(
    zi,
    {
      ...o,
      classes: g.ifFeature("encore", void 0, y),
      "data-fabric-component": "MultiSelectTransferList",
      leftListItems: W,
      LeftTransferListBaseProps: {
        ...v,
        blankState: v.blankState ?? (() => W.length === 0 && (D.trim().length > 0 || M.length > 0) ? /* @__PURE__ */ l.jsx("div", { className: d.noMatchFilter, children: f }) : void 0),
        listHeaderChildren: v.listHeaderChildren ?? (() => /* @__PURE__ */ l.jsxs(l.Fragment, { children: [
          a && /* @__PURE__ */ l.jsx(
            bt,
            {
              ...a,
              onChange: (P) => {
                Z(P.filters || [], D);
              }
            }
          ),
          i && /* @__PURE__ */ l.jsx(
            Wt,
            {
              ...i,
              onChange: (P) => {
                Z(M, P);
              }
            }
          )
        ] }))
      },
      onLeftRowSelect: ne,
      onRightRowSelect: X,
      renderButtonControls: Q,
      rightListItems: H,
      RightTransferListBaseProps: {
        ...S
      },
      variant: p
    }
  );
}
const Ui = A()(({ mode: t, palette: e, typography: r }) => ({
  searchInput: {
    marginBottom: 15,
    outline: t === F.Dye ? `1px solid ${R.main}` : void 0,
    width: "235px"
  },
  dropdownList: {
    maxHeight: "180px",
    overflowX: "hidden"
  },
  dropdownOption: {
    boxSizing: "border-box",
    fontSize: r.small.fontSize,
    height: "16px",
    padding: "10px 15px",
    width: "439px",
    "&:hover": {
      backgroundColor: e.primary.main,
      color: e.common.white
    }
  }
})), Gi = (t) => {
  const { label: e, leftListItems: r, selectedOptions: n, placeholder: i, onSelect: o } = t, { classes: s } = Ui();
  return /* @__PURE__ */ l.jsx("div", { className: s.searchInput, children: /* @__PURE__ */ l.jsx(
    or,
    {
      classes: { listbox: s.dropdownList, option: s.dropdownOption },
      closeOnSelect: !0,
      getOptionLabel: (a) => a.title,
      label: e,
      onChange: (a, c) => {
        const { value: u, rowKey: f } = a.value[0];
        o({ value: u, key: f }, c.nativeEvent);
      },
      options: n.length > 0 ? r.filter((a) => !n.find((c) => c.rowKey === a.rowKey)) : [...r],
      placeholder: i,
      value: []
    }
  ) });
}, mo = {
  BlankState: sr,
  ButtonControls: vt,
  FilterSelect: bt,
  SearchBar: Wt,
  TransferListItem: Ke,
  TransferListBase: $e,
  TransferListHoverItem: ue,
  TransferListCategory: Bt,
  TransferListSubcategory: qe,
  SelectSearchBar: Gi,
  TransferListCategoryList: zt
};
export {
  po as M,
  mo as T,
  zi as a,
  yt as b,
  cr as c,
  dr as d,
  hr as e,
  ye as f,
  gr as g,
  K as h,
  pr as i,
  ho as j,
  yr as k,
  z as l,
  fr as m,
  L as n,
  ur as p,
  lr as s,
  St as u
};
//# sourceMappingURL=index-DDLJm-Ri.mjs.map
